import {
    BankOutlined,
    BulbFilled,
    CloudUploadOutlined,
    DownloadOutlined,
    EnvironmentOutlined,
    FolderOpenOutlined,
    InfoCircleFilled,
    TeamOutlined,
} from '@ant-design/icons';
import { Button, Col, Divider, Flex, InputNumber, message, Modal, Radio, Row, Skeleton, Space, Spin, Typography, Upload } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { Alert } from "components/elements";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from 'dayjs';
import { exportTxnPaymentByTxnPayrollPeriodIdXlsx, uploadEmployeeGroupCalculation } from "features/employee/services/employeeApi";
import { previewPaySlipById } from "features/employee/services/salaryApi";
import usePayrollPeriod from "features/payroll/hook/usePayrollPeriod";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
    generateRandomString
} from "utils/helper";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import ApprovalPage from "../components/ApprovalPage";
import CalculationPage from "../components/CalculationPage";
import ClosePage from "../components/ClosePage";
import IncomeDeductionSetupModal from "../components/IncomeDeductionSetupModal";
import PaymentModal from "../components/PaymentModal";
import PaymentPage from "../components/PaymentPage";
import PayrollModal from "../components/PayrollModal";
import RejectReasonModal from "../components/RejectReasonModal";
import VerificationPage from "../components/VerificationPage";
import { ACTION, PAYMENT_METHOD, PAYMENT_STEP, PAYROLL_PERIOD_STATUS } from "../schemas/PaymentShemas";
import * as service from "../services/paymentApi";
import {
    setCountTxnPaymentStatus,
    setEmployeeGroupCalculation,
    setEmployeeIncomeDeduction,
    setEmployeeIncomeDeductionDefalut,
    setEmployeeList,
    setEmploymentDeduct,
    setEmploymentIncome,
    setEmploymentIncomeDeduction,
    setEmploymentTypeList,
    setIncompleteList,
    setIsLoading,
    setIsLoadingFile,
    setIsTextFileLoading,
    setNewEmployeeList,
    setResignList,
    setRoleList,
    setTotalEmployeeTab
} from "../slices/PaymentSlices";
import ApprovalTable from "../table/ApprovalTable";
import CloseTable from "../table/CloseTable";
import EmployeeIncompleteTable from "../table/EmployeeIncompleteTable";
import PaymentTable from "../table/PaymentTable";
import VerificationTable from "../table/VerificationTable";

function usePayment() {
    const dispatch = useDispatch()
    const [form] = useForm();
    const [formCalGroup] = useForm();
    const { i18n, t } = useTranslation()
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)
    const {
        roleList,
        workInLocationList,
        employmentTypeList,
        payrollPeriod,
        employeeList,
        isLoading,
        isLoadingFile,
        totalEmployeeTab,
        incompleteList,
        newEmployeeList,
        resignList,
        employeeIncomeDeduction,
        employeeIncomeDeductionDefalut,
        countTxnPaymentByStatus,
        employmentIncome,
        employmentDeduct,
        isTextFileLoading
    } = useSelector((state) => state.payment)
    console.log("isLoadingFile", isLoadingFile);


    const { getPayrollPeriod = () => { }, createPaymentByEmployeeIds = () => { } } = usePayrollPeriod()
    const { id } = useParams();
    const navigate = useNavigate()
    let payrollPeriodId = id;
    const [tab, setTab] = useState("all");
    const [action, setAction] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenSlip, setIsModalOpenSlip] = useState(false);
    const [isModalIncomeDeductOpen, setIsModalIncomeDeductOpen] = useState(false);
    const [isModalRejectReasonOpen, setIsModalRejectReasonOpen] = useState(false);
    const [isModalDocumentOpen, setIsModalDocumentOpen] = useState(false);
    const [isModalSalaryOpen, setIsModalSalaryOpen] = useState(false);
    const [incomeDeductType, setIncomeDeductType] = useState("income");
    const [pagination, setPagination] = useState({ page: 0, size: 10 });
    const [visible, setVisible] = useState(false);
    const [rowSelected, setRowSelected] = useState();
    const [employeeIncome, setEmployeeIncome] = useState();
    const [employeeDeduct, setEmployeeDeduct] = useState();
    const [selectedIncomeDeductType, setSelectedIncomeDeductType] = useState([]);
    const [buttonState, setButtonState] = useState(ACTION.PREVIEW);
    const [pageStatus, setPageStatus] = useState('0');
    const [pageByStep, setPageByStep] = useState("1");
    const [incomeSetup, setIncomeSetup] = useState();
    const [deductSetup, setDeductSetup] = useState();
    const [company, setCompany] = useState();
    const [currentTxnPayment, setCurrentTxnPayment] = useState();
    const [editingTax, setEditingTax] = useState("N");
    function xlsxIcon() {
        return <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.4843 1.84619H9.84619V3.6825H11.7114V4.93235H9.84619V6.15388H11.6923V7.38465H9.84619V8.61542H11.6923V9.84619H9.84619V11.077H11.6923V12.3077H9.84619V14.1539H15.4843C15.768 14.1539 16 13.9133 16 13.6185V2.38158C16 2.08681 15.768 1.84619 15.4843 1.84619ZM14.7693 12.3077H12.3077V11.077H14.7693V12.3077ZM14.7693 9.84619H12.3077V8.61542H14.7693V9.84619ZM14.7693 7.38465H12.3077V6.15388H14.7693V7.38465ZM14.7693 4.92311H12.3077V3.69235H14.7693V4.92311Z" fill="#1E6E42" />
            <path d="M0 1.77785V14.2228L9.23077 16V0L0 1.77785ZM5.83877 11.1262L4.76492 9.096C4.72431 9.02031 4.68246 8.88123 4.63877 8.67877H4.62215C4.60185 8.77415 4.55385 8.91938 4.47815 9.11385L3.40062 11.1262H1.72738L3.71385 8.00985L1.89662 4.89292H3.60492L4.496 6.76185C4.56554 6.90954 4.62769 7.08492 4.68308 7.28738H4.70031C4.73538 7.16554 4.80062 6.98462 4.896 6.744L5.88677 4.89231H7.45108L5.58215 7.98277L7.50338 11.1255L5.83877 11.1262Z" fill="#1E6E42" />
        </svg>

    }
    const [calGroupStep, setCalGroupStep] = useState(1);
    const [employeeGroupMode, setEmployeeGroupMode] = useState('all'); // 'all' | 'partial'
    const [uploadFiles, setUploadFiles] = useState([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleImportEmployeeGroupCalculation = async () => {
        if (uploadFiles.length === 0) return;

        dispatch(setIsLoadingFile(true));
        try {
            await uploadEmployeeGroupCalculation({
                files: uploadFiles,
                txnPayrollPeriodId: id,
            }).then((res) => {
                console.log("res?.data?.content", res?.data?.content);
                let ids = []
                res?.data?.content.forEach(o => {
                    const { income, deduction } = o
                    // console.log("income, deduction", income, deduction);
                    // setCalSuccess();
                    ids.push(o.id)
                    income.forEach(inc => {
                        if (inc?.income?.code == 'I01') {
                            form.setFieldValue(`I01amount_${o.id}`, inc.amount)
                            form.setFieldValue(`I01unit_${o.id}`, inc.unit)
                        } else {

                            console.log("income, deduction", `${inc.id}_amount_${o.id}`, inc.unit);
                            form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                            form.setFieldValue(`${inc.id}_unit_${o.id}`, inc.unit)
                        }
                    })
                    deduction.forEach(inc => {
                        form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                    })
                })
                // setCalSuccess(ids);
                dispatch(setEmployeeGroupCalculation(res?.data?.content))
                navigate(`/payroll/payment/group_calculation/${payrollPeriodId}`);
            })

            message.success('นำเข้าข้อมูลเงินเดือนสำเร็จ');
            closeCalGroupModal();
            // refresh whatever list/table is behind this modal, e.g.:
            // getTxnPaymentListByPaginationSize(formCalGroup.getFieldsValue(true));
        } catch (err) {
            message.error(
                err?.response?.data?.message || 'นำเข้าข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
            );
        } finally {
            dispatch(setIsLoadingFile(false));
        }
    };

    const closeCalGroupModal = useCallback(() => {
        setOpenCalGroup({ open: false });
        formCalGroup.resetFields();
        setCalGroupStep(1);
        setEmployeeGroupMode('all');
        setUploadFiles([]);
    }, [formCalGroup]);
    const modalDownload = useCallback(async (param) => {
        try {
            dispatch(setIsLoadingFile(true));
            await exportTxnPaymentByTxnPayrollPeriodIdXlsx(param).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "import-payroll-template.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
        } catch (error) {
        } finally {
            dispatch(setIsLoadingFile(false));
        }
    },
        [dispatch],
    )

    // * filter
    const [departmentFilter, setDepartmentFilter] = useState();
    const [employmentTypeFilter, setEmploymentTypeFilter] = useState();
    const [roleFilter, setRoleFilter] = useState();
    const [workInFilter, setWorkInFilter] = useState();
    const [searchTxt, setSearchTxt] = useState();
    const [paymentTypeMethod, setPaymentTypeMethod] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [exportStatus, setExportStatus] = useState(null)
    const [isDownload, setIsDownload] = useState(false);
    const [isSlipDownload, setIsSlipDownload] = useState(false);
    const [openCalGroup, setOpenCalGroup] = useState({
        open: false
    })

    const [branchList, setBranchList] = useState([])
    const [departmentList, setDepartmentList] = useState([])


    const exportStatusList = [
        {
            nameEn: "Sent",
            name: "ส่งแล้ว",
            value: "SEND"
        },
        {
            nameEn: "Rejected",
            name: "ถูกปฎิเสธ",
            value: "REJECT"
        },
        {
            nameEn: "Fail",
            name: "ส่งไม่สำเร็จ",
            value: "FAIL"
        },
    ]

    const STATUS_TYPE = useMemo(() => {
        return [
            {
                title: 'Pending',
                nameEn: 'Pending',
                name: 'รอการคำนวณ',
                key: '0',
                values: countTxnPaymentByStatus?.find((o) => o?.status == 0)?.count || 0
            },
            {
                title: 'Calculated',
                nameEn: 'Calculated',
                name: 'คำนวณเรียบร้อยแล้ว',
                key: '1',
                values: countTxnPaymentByStatus?.find((o) => o?.status == 1)?.count || 0
            },
            {
                title: 'Verified',
                nameEn: 'Verified',
                name: 'ตรวจสอบแล้ว',
                key: '2',
                values: countTxnPaymentByStatus?.find((o) => o?.status == 2)?.count || 0
            }
        ]
    }, [countTxnPaymentByStatus])

    const VERIFICATION_TYPE = useMemo(() => {
        return [
            {
                title: 'Pending verification',
                nameEn: 'Pending verification',
                name: 'รอตรวจสอบ',
                key: '0',
                values: countTxnPaymentByStatus?.find((o) => o?.status == 1)?.count || 0
            },
            {
                title: 'Verified',
                nameEn: 'Verified',
                name: 'ตรวจสอบแล้ว',
                key: '1',
                values: countTxnPaymentByStatus
                    ?.filter((o) => o?.status === 2 || o?.status === 1.5)
                    ?.reduce((sum, o) => sum + (o?.count || 0), 0)
            },
            {
                title: 'Rejected',
                nameEn: 'Rejected',
                name: 'ไม่ผ่านการตรวจสอบ',
                key: '1.5',
                values: countTxnPaymentByStatus?.find((o) => o?.status == 2.5)?.count || 0
            }
        ]
    }, [countTxnPaymentByStatus])

    const modifiedExportStatusDropdown = useMemo(() => {
        const modifiedOptions = exportStatusList?.map((xx) => {
            return {
                label: i18n.language === 'en' ? xx.nameEn : xx.name,
                value: xx.value
            }
        })
        return modifiedOptions
    }, [i18n.language])

    const modifiedEmploymentTypeList = useMemo(() => {
        const modifiedOptions = employmentTypeList?.map((employmentType) => {
            return {
                label: i18n.language === 'en' ? employmentType?.employmentTypeNameEn : employmentType?.employmentTypeName,
                value: employmentType?.id
            }
        })
        return modifiedOptions
    }, [employmentTypeList, i18n.language])

    const modifiedDepartmentList = useMemo(() => {
        console.log("departmentList", departmentList);

        const modifiedOptions = departmentList?.map((department) => {
            return {
                label: i18n.language === 'en' ? department?.organizationNameEn : department?.organizationName,
                value: department?.id
            }
        })
        return modifiedOptions
    }, [departmentList, i18n.language])
    const modifiedBranchList = useMemo(() => {
        console.log("branchList", branchList);
        const modifiedOptions = branchList?.map((branch) => {
            return {
                label: i18n.language === 'en' ? branch?.branchNameEn : branch?.branchName,
                value: branch?.id
            }
        })
        return modifiedOptions
    }, [branchList, i18n.language])

    const modifiedRoleList = useMemo(() => {
        const modifiedOptions = roleList?.map((role) => {
            return {
                label: i18n.language === 'en' ? role?.roleNameEn : role?.roleName,
                value: role?.id
            }
        })
        return modifiedOptions
    }, [roleList, i18n.language])

    const modifiedWorkInLocationList = useMemo(() => {
        const modifiedOptions = workInLocationList?.map((workInLocation) => {
            return {
                label: workInLocation?.workInLocationName,
                value: workInLocation?.workInLocationId
            }
        })
        return modifiedOptions
    }, [workInLocationList])

    const modifiedPaymentMethod = useMemo(() => {
        const modifiedOptions = PAYMENT_METHOD.map((opt) => {
            return {
                label: i18n.language === 'en' ? opt.nameEn : opt.name,
                value: opt.key
            }
        })
        return modifiedOptions
    }, [i18n.language])

    const modifiedStep = useMemo(() => {
        const modifiedOptions = PAYMENT_STEP.map((opt) => {
            return {
                title: i18n.language === 'en' ? opt.nameEn : opt.name,
                value: opt.key
            }
        })
        return modifiedOptions
    }, [i18n.language])



    const onResetList = useCallback(
        () => {
            // setEmployeeIncome(model)
            // setEmployeeDeduct(deduct)

            let totalWorkingDays = Number(currentTxnPayment?.totalWorkingDays ?? 0);
            let daysForDividing = Number(currentTxnPayment?.daysForDividing ?? 1);

            let income = employeeIncomeDeductionDefalut?.income;
            let deduction = employeeIncomeDeductionDefalut?.deduction

            let mergeIncome = [...(employeeIncome?.map?.(o => ({
                ...o,
                amount: o?.income?.code?.match("(I01)") ? Number((Number(income?.find(o1 => o1?.income?.code?.match("(I01)"))?.amount) * Number(totalWorkingDays / daysForDividing))).toFixed(2) : (income?.find(o1 => o1.id == o.id)?.amount) || o.amount
            })) ?? [])]
            let deductionIncome = [...(employeeDeduct?.map?.(o => ({
                ...o,
                amount: o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") ? deduction?.find(o1 => o1?.deduction?.code?.match("(D14|D11|D01|D13|D12)"))?.amount : (deduction?.find(o1 => o1.id == o.id)?.amount) || o.amount,
                modified: o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") ? deduction?.find(o1 => o1?.deduction?.code?.match("(D14|D11|D01|D13|D12)"))?.modified : (deduction?.find(o1 => o1.id == o.id)?.modified) || o.modified
            })) ?? [])]
                ;
            // || o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && e?.deduction?.code?.match("(D14|D11|D01|D13|D12)")
            // || o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && e?.deduction?.code?.match("(D14|D11|D01|D13|D12)")
            let incomeAdd = income?.filter?.(o => !employeeIncome?.some?.(i => i.id == o.id) && !o?.income?.code?.match("(I01)") || (o?.income?.code?.match("(I01)") && !employeeIncome?.some?.(i => i?.income?.code?.match("(I01)"))))
            let deductionAdd = deduction?.filter?.(o => !employeeDeduct?.some?.(i => i.id == o.id) && !o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") || (o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && !employeeDeduct?.some?.(i => i?.deduction?.code?.match("(D14|D11|D01|D13|D12)"))))
            incomeAdd?.forEach?.(o => mergeIncome.push(o));
            deductionAdd?.forEach?.(o => deductionIncome.push(o));
            console.log("incomeAdd", incomeAdd);
            console.log("deductionAdd", deductionAdd);
            // mergeIncome.push()
            mergeIncome = mergeIncome.sort((o1, o2) => {
                const code1 = o1?.income?.code || "";
                const code2 = o2?.income?.code || "";

                return code1.localeCompare(code2);
            });
            deductionIncome = deductionIncome.sort((o1, o2) => {
                const code1 = o1?.deduction?.code || "";
                const code2 = o2?.deduction?.code || "";

                return code1.localeCompare(code2);
            });


            console.log("mergeIncomedeductionIncome", mergeIncome, deductionIncome);
            setEmployeeIncome(mergeIncome)
            setEmployeeDeduct(deductionIncome)
            // employeeIncome
        },
        [employeeIncomeDeductionDefalut, selectedIncomeDeductType, employeeIncome, employeeDeduct],
    )

    const onConfirmReset = () => {
        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: t("dialog.confirmation.reset"),
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
            onOk: () => onResetList(),
        });
    };

    const PAYMENT_TAB = useMemo(() => {
        return [
            {
                key: 'all',
                label: i18n.language === 'en' ? "All" : "ทั้งหมด",
                values: totalEmployeeTab?.allEmployee
            },
            {
                key: 'incompleteData',
                label: i18n.language === 'en' ? "Employee incomplete data" : "พนักงานข้อมูลไม่ครบ",
                values: totalEmployeeTab?.countIncomplete
            },
            {
                key: 'employeeIn',
                label: i18n.language === 'en' ? "New employee in this period" : "พนักงานเข้าใหม่งวดนี้",
                values: totalEmployeeTab?.countNewEmployee
            },
            {
                key: 'employeeOut',
                label: i18n.language === 'en' ? "Employee resigned in this period" : "พนักงานลาออกงวดนี้",
                values: totalEmployeeTab?.countResignEmployee
            },
            {
                key: 'editedItems',
                label: i18n.language === 'en' ? "Edit history" : "ประวัติการแก้ไข",
            },
        ];
    }, [totalEmployeeTab, i18n.language]);

    const confirmModalFn = useCallback((fn = () => { }, confirmMsg = "") => {
        console.log("confirm modal");

        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: confirmMsg,
            onOk() {
                fn();
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [])




    // useEffect(() => {
    //     if (employeeIncome && employmentIncomeDeduction) {
    //         let incomeTypeFilter = employmentIncomeDeduction?.incomes
    //             ?.filter((employmentIncome) => {
    //                 return !employeeIncome?.some((o) => o?.income?.id === employmentIncome?.income?.id);
    //             })
    //             .map((income) => {
    //                 return {
    //                     ...income
    //                 };
    //             });
    //         setEmploymentIncome(incomeTypeFilter)
    //     }

    //     if (employeeDeduct && employmentIncomeDeduction) {
    //         let deductTypeFilter = employmentIncomeDeduction?.deductions?.filter((employmentDeduct) => {
    //             return !employeeDeduct?.some((o) => o?.deduction?.id === employmentDeduct?.deduction?.id);
    //         }).map((deduction) => {
    //             return {
    //                 ...deduction
    //             };
    //         });
    //         setEmploymentDeduct(deductTypeFilter)
    //     }
    // }, [employeeIncome, employeeDeduct, employmentIncomeDeduction])

    let modifiedIncomeDeduction = useMemo(() => {
        return {
            incomeList: employeeIncome,
            deductionList: employeeDeduct,
        }
    }, [employeeIncome, employeeDeduct])

    const onChange = useCallback((values) => {
        setTab(values)
        setExportStatus()
        setSearchTxt()
        setRowSelected([])
    }, [])

    const onCancel = useCallback(() => {
        setIsModalOpen(false)
        setButtonState(ACTION.PREVIEW)
        setEmployeeIncome()
        setEmployeeDeduct()
        setSelectedIncomeDeductType([])
        // if (currentTxnPayment) {
        //     getDefultIncomeDeduct()
        // }
    }, [currentTxnPayment])

    const onClearSelected = useCallback(() => {
        setRowSelected([])
    }, [])

    const onRowSelected = useCallback((e) => {
        setRowSelected(e)
    }, [])

    const onPageStatusChange = useCallback((e) => {
        setPageStatus(e)
        setExportStatus()
        setRowSelected([])
        setTab(PAYMENT_TAB[0].key)
        setSearchTxt()
    }, [pageStatus])

    const onRejectModalOpen = useCallback(() => {
        setIsModalRejectReasonOpen(true)
    }, [])

    const onRejectModalClose = useCallback(() => {
        setIsModalRejectReasonOpen(false)
    }, [])

    const onDocumentModalOpen = useCallback(() => {
        setIsModalDocumentOpen(true)
    }, [])

    const onDocumentModalClose = useCallback(() => {
        setIsModalDocumentOpen(false)
    }, [])




    const rowSelection = useMemo(() => {

        // if (payrollPeriod?.step > 0) {
        return {
            selectedRowKeys: rowSelected,
            onChange: onRowSelected
        }
        // } else {
        //     return false
        // }
    }, [rowSelected, payrollPeriod])




    const getEmploymentType = useCallback(async () => {
        try {
            // dispatch(setIsLoading(true))
            const response = await service.getEmploymentTypeSetup({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee
            })
            dispatch(setEmploymentTypeList(response?.data?.employmentTypeSetupList))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, employmentTypeList])

    const getRole = useCallback(async () => {
        try {
            // dispatch(setIsLoading(true))
            const response = await service.getRole({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee
            })
            dispatch(setRoleList(response?.data))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            // dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    // const getDepartment = useCallback(async () => {
    //     try {
    //         // dispatch(setIsLoading(true))
    //         const response = await service.getDepartment({
    //             companyId: currentCompany,
    //             employeeId: currentEmployee,
    //             actionId: currentEmployee
    //         })
    //         dispatch(setDepartmentList(response?.data))
    //         // Alert({ message: 'success', type: 'success' })
    //     } catch (error) {
    //         Alert({ type: 'error', resultObject: error })
    //     } finally {
    //         // dispatch(setIsLoading(false))
    //     }
    // }, [currentCompany, currentEmployee, dispatch])


    // const getWorkInLocation = useCallback(async () => {
    //     try {
    //         // dispatch(setIsLoading(true))
    //         const response = await getBranch({
    //             companyId: currentCompany,
    //             employeeId: currentEmployee,
    //             actionId: currentEmployee
    //         })
    //         // useFetchOptions(services.getBranch, currentCompany, "", slices.setBranchOptions);
    //         dispatch(setWorkInLocationList(response?.data))
    //         // Alert({ message: 'success', type: 'success' })
    //     } catch (error) {
    //         Alert({ type: 'error', resultObject: error })
    //     } finally {
    //         // dispatch(setIsLoading(false))
    //     }
    // }, [currentCompany, currentEmployee, dispatch])

    // useEffect(() => {
    //     getDepartment()
    //     getWorkInLocation()

    //     //   return () => {
    //     //     second
    //     //   }
    // }, [getDepartment, getWorkInLocation])




    const getEmployeeList = useCallback(async (params) => {

        if (payrollPeriodId) {
            try {
                dispatch(setIsLoading(true))
                let response;
                let status = [pageStatus];
                let headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
                switch (pageByStep) {
                    case '1':
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
                        break;
                    case '2':
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_VERIFICATION
                        break;
                    case '3':
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_APPROVAL
                        break;
                    case '4':
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CLOSE
                        break;
                    case '5':
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_PAYMENT
                        break;

                    default:
                        headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
                        break;
                }
                if (pageByStep === '2') {
                    status = [Number(pageStatus) + 1];
                }
                if (pageByStep === '2' && pageStatus === '1') {
                    status = [1.5, 2.0]
                }
                if (pageByStep >= 3) {
                    status = [2]
                }

                if (pageByStep === '1') {

                    switch (tab) {
                        case PAYMENT_TAB[0].key:
                            response = await service.getEmployeePayment({
                                companyId: currentCompany,
                                employeeId: currentEmployee,
                                actionId: currentEmployee,
                                txnPayrollPeriodId: payrollPeriodId,
                                departmentId: departmentFilter,
                                employmentTypeId: employmentTypeFilter,
                                roleId: roleFilter,
                                workInLocationId: workInFilter,
                                paymentMethod: paymentTypeMethod,
                                headerStatus: headerStatus,
                                status: status,
                                ...params,
                            })
                            dispatch(setEmployeeList(response?.data?.content))
                            break;
                        case PAYMENT_TAB[1].key:
                            response = await service.getEmployeeByTab({
                                companyId: currentCompany,
                                employeeId: currentEmployee,
                                actionId: currentEmployee,
                                txnPayrollPeriodId: payrollPeriodId,
                                departmentId: departmentFilter,
                                employmentTypeId: employmentTypeFilter,
                                roleId: roleFilter,
                                workInLocationId: workInFilter,
                                paymentMethod: paymentTypeMethod,
                                headerStatus: headerStatus,
                                type: "INCOMPLETE",
                                status: 0,
                                ...params,
                            })
                            dispatch(setIncompleteList(response?.data?.content))
                            break;
                        case PAYMENT_TAB[2].key:
                            response = await service.getEmployeeByTab({
                                companyId: currentCompany,
                                employeeId: currentEmployee,
                                actionId: currentEmployee,
                                txnPayrollPeriodId: payrollPeriodId,
                                departmentId: departmentFilter,
                                employmentTypeId: employmentTypeFilter,
                                roleId: roleFilter,
                                workInLocationId: workInFilter,
                                paymentMethod: paymentTypeMethod,
                                headerStatus: headerStatus,
                                // searchTxt: searchTxt,
                                type: "NEW_EMPLOYEE",

                                status: 0,
                                ...params,
                            })
                            dispatch(setNewEmployeeList(response?.data?.content))
                            break;
                        case PAYMENT_TAB[3].key:
                            response = await service.getEmployeeByTab({
                                companyId: currentCompany,
                                employeeId: currentEmployee,
                                actionId: currentEmployee,
                                txnPayrollPeriodId: payrollPeriodId,
                                departmentId: departmentFilter,
                                employmentTypeId: employmentTypeFilter,
                                roleId: roleFilter,
                                workInLocationId: workInFilter,
                                paymentMethod: paymentTypeMethod,
                                headerStatus: headerStatus,
                                type: "RESIGN",
                                status: 0,
                                ...params,
                            })
                            dispatch(setResignList(response?.data?.content))
                            break;
                        case PAYMENT_TAB[4].key:
                            response = await service.getEmployeePayment({
                                companyId: currentCompany,
                                employeeId: currentEmployee,
                                actionId: currentEmployee,
                                txnPayrollPeriodId: payrollPeriodId,
                                departmentId: departmentFilter,
                                employmentTypeId: employmentTypeFilter,
                                roleId: roleFilter,
                                workInLocationId: workInFilter,
                                paymentMethod: paymentTypeMethod,
                                status: 0,
                                headerStatus: headerStatus,
                                ...params,
                            })
                            break;
                        default:
                            break;
                    }
                } else {
                    response = await service.getEmployeePayment({
                        companyId: currentCompany,
                        employeeId: currentEmployee,
                        actionId: currentEmployee,
                        txnPayrollPeriodId: payrollPeriodId,
                        departmentId: departmentFilter,
                        employmentTypeId: employmentTypeFilter,
                        roleId: roleFilter,
                        workInLocationId: workInFilter,
                        paymentMethod: paymentTypeMethod,
                        headerStatus: headerStatus,
                        status: status,
                        exportStatus: exportStatus,
                        ...params,
                    })
                    dispatch(setEmployeeList(response?.data?.content))
                }

                setPagination({
                    ...params?.pagination,
                    current: response?.data?.pageNo + 1,
                    pageNo: response?.data?.pageNo + 1,
                    page: response?.data?.pageNo + 1,
                    total: response.data?.totalItems,
                    size: response?.data?.pageSize
                });
            } catch (error) {
                Alert({ type: 'error', resultObject: error })
            } finally {
                dispatch(setIsLoading(false))
            }
        }
    }, [currentCompany,
        currentEmployee,
        tab,
        departmentFilter,
        employmentTypeFilter,
        roleFilter,
        workInFilter,
        paymentTypeMethod,
        searchTxt,
        payrollPeriod,
        pageStatus,
        pageByStep,
        onChange,
        exportStatus
    ])


    const onExportStatusChange = useCallback((exportStatus) => {
        setExportStatus(exportStatus)
        const modifiedRevalues = {
            ...searchTxt,
            exportStatus: exportStatus,
            page: 0,
            size: 10
        }
        getEmployeeList(modifiedRevalues)
    }, [searchTxt])

    const onSearch = useCallback(async (values) => {
        if (currentCompany) {
            setSearchTxt(values)
            const modifiedRevalues = {
                ...values,
                exportStatus: exportStatus,
                page: 0,
                size: 10
            }
            getEmployeeList(modifiedRevalues)
        }
    }, [currentCompany, getEmployeeList, exportStatus])

    const onPageByStepChange = useCallback((e) => {
        setPageByStep(e)
        setPageStatus('0')
        setRowSelected([])
        setTab("all")
        dispatch(setEmployeeList())
        dispatch(setIncompleteList())
        dispatch(setNewEmployeeList())
        dispatch(setResignList())
    }, [])

    const onClearSearchTxt = useCallback(async () => {
        setSearchTxt(null)
        if (currentCompany) {
            getEmployeeList({
                page: 0,
                size: 10
            })
        }
    }, [currentCompany, getEmployeeList])

    const getTotalEmployeeTab = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.getEmployeeByTab({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                type: "COUNT",
            })
            dispatch(setTotalEmployeeTab(response?.data?.content))

        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])



    const getCountTxnPaymentByStatus = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            let headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
            switch (pageByStep) {
                case '1':
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
                    break;
                case '2':
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_VERIFICATION
                    break;
                case '3':
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_APPROVAL
                    break;
                case '4':
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CLOSE
                    break;
                case '5':
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_PAYMENT
                    break;

                default:
                    headerStatus = PAYROLL_PERIOD_STATUS.PENDING_CALCULATION
                    break;
            }
            const response = await service.countTxnPaymentByStatus({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                status: headerStatus
            })
            dispatch(setCountTxnPaymentStatus(response?.data?.content))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, pageByStep])

    const updateTxnPaymentEmployeeIncomeDeduct = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            // let modifiedDeduct = values?.deductionList?.map((o) => {
            //     return {
            //         ...o,
            //         amount: o?.amount?.replace(/,/g, "")
            //     }
            // })
            // let modifiedIncome = values?.incomeList?.map((o) => {
            //     return {
            //         ...o,
            //         amount: o?.amount?.replace(/,/g, "")
            //     }
            // })
            await service.updateTxnPaymentEmployeeIncomeDeduct({
                txnPaymentId: currentTxnPayment?.txnPaymentId,
                ...employeeIncomeDeduction,
                companyId: currentCompany,
                actionId: currentEmployee,
                employeeId: currentTxnPayment?.employeeId,
                editingTax: editingTax,
                overtimeRequestId: values.overtimeRequestId
            })
            getEmployeeList({ page: 0, size: 10 })

            getCountTxnPaymentByStatus()
            getTotalEmployeeTab()
            setIsModalOpen(false)
            setEditingTax("N")
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
            setButtonState(ACTION.PREVIEW)
        }

    }, [currentTxnPayment, currentCompany, currentEmployee, editingTax, getEmployeeList, getCountTxnPaymentByStatus, getTotalEmployeeTab, employeeIncomeDeduction])


    const onSubmitEditPayroll = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const modified = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                paymentDate: record?.paymentDate
            }
            await service.updatePaymentDate(modified);
            await getPayrollPeriod(payrollPeriodId)
            form.setFieldValue("paymentDate", dayjs(payrollPeriod?.paymentDate))
            onCancel()
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, payrollPeriod, payrollPeriodId, form])

    const returnPayment = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const modified = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            }

            await service.returnPayment(modified);
            await getPayrollPeriod(payrollPeriod?.id)
            // await createPayment()
            await getEmployeeList({ page: 0, size: 10 })

            setIsModalOpen(false)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, payrollPeriodId, pagination, getEmployeeList])

    // * p' ice
    const getEmploymentTypeIncomeDeductForSetup = useCallback(async (incomeOrDeduct) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.geIncomeDeductionByStpEmploymentTypeForSetup({
                companyId: currentCompany,
                employeeId: currentTxnPayment?.employeeId || currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                // txnPaymentId: currentTxnPayment?.txnPaymentId,
                // type: incomeOrDeduct
            })
            dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            dispatch(setEmploymentIncome(response?.data?.content?.employeeIncome || []))
            dispatch(setEmploymentDeduct(response?.data?.content?.employeeDeduction || []))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, currentTxnPayment])

    const exportTxnPayment = useCallback(async () => {
        setIsDownload(true);
        try {
            const baseRequest = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            }
            dispatch(setIsLoading(true))
            await service.exportTxnPaymentByTxnPayrollPeriodId(baseRequest).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "employee-income-report.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
            setIsDownload(false);
        }
    }, [currentCompany, currentEmployee, payrollPeriodId])

    const exportPaymentSlip = useCallback(async () => {
        setIsSlipDownload(true);
        try {
            const baseRequest = {
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            }
            dispatch(setIsLoading(true))
            await service.exportEmployeePaySlip(baseRequest).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "employee-salary-slip.pdf");
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
            setIsSlipDownload(false);
        }
    }, [currentEmployee, dispatch, payrollPeriodId])

    const getOvertimeInPeriod = useCallback(async ({ date, fn }) => {
        try {
            dispatch(setIsLoading(true))
            console.log("getOvertimeInPeriod", date);
            let startPeriod = date?.[0]?.format?.("YYYY-MM-DD")
            let endPeriod = date?.[1]?.format?.("YYYY-MM-DD")
            const response = await service.getOvertimeInPeriod({
                companyId: currentCompany,
                employeeId: currentTxnPayment?.employeeId,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                startPeriod,
                endPeriod
                // txnPaymentId: currentTxnPayment?.txnPaymentId,
                // type: incomeOrDeduct
            })
            fn?.(response?.data?.content)
            // dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            // dispatch(setEmploymentIncome(sponsresponse?.data?.content?.employeeIncome || []))
            // dispatch(setEmploymentDeduct(ree?.data?.content?.employeeDeduction || []))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, currentTxnPayment])



    const onCancelIncomeDeductType = useCallback(() => {
        let a = []
        console.log("onCancelIncomeDeductType");

        setIsModalIncomeDeductOpen(false);
        setSelectedIncomeDeductType()
        // console.log("modifiedIncomeDeduction.incomeList.includes(i => i.id = o.id))", incomeSetup.filter(o => modifiedIncomeDeduction.incomeList.some(i => i.id == o.id)));
        // console.log("modifiedIncomeDeduction.deductionList.includes(i => i.id = o.id))", deductSetup.filter(o => modifiedIncomeDeduction.deductionList.some(i => i.id == o.id)));
        setIncomeSetup(incomeSetup.map(o => ({
            ...o,
            flag: modifiedIncomeDeduction.incomeList?.some?.(i => i.id == o.id) ? "Y" : "N",
            status: modifiedIncomeDeduction.incomeList?.some?.(i => i.id == o.id) ? "Y" : "N",
            statusFlag: modifiedIncomeDeduction.incomeList?.some?.(i => i.id == o.id) ? "Y" : "N",
        })))
        setDeductSetup(deductSetup.map(o => ({
            ...o,
            flag: modifiedIncomeDeduction.deductionList?.some?.(i => i.id == o.id) ? "Y" : "N",
            status: modifiedIncomeDeduction.deductionList?.some?.(i => i.id == o.id) ? "Y" : "N",
            statusFlag: modifiedIncomeDeduction.deductionList?.some?.(i => i.id == o.id) ? "Y" : "N",
        })))
        setIsModalOpen(true)
    }, [isModalIncomeDeductOpen, buttonState, incomeSetup, modifiedIncomeDeduction, deductSetup, setIncomeSetup, setDeductSetup])

    const onIncomeDeductTypeSelected = useCallback((e, flag) => {

        let selectedType = []
        //     ? [...selectedIncomeDeductType]
        //     : [];
        // selectedType.push
        // // let type = e?.deduction?.id ? "deduction" : "income"
        // console.log("flag", flag);
        // let modifiedData = {
        //     ...e,
        //     flag: flag === true ? 'Y' : 'N',
        //     status: flag === true ? 'Y' : 'N',
        //     statusFlag: flag === true ? 'Y' : 'N',
        // }
        // if (selectedType?.length == 0) {
        //     selectedType?.push(modifiedData)

        // } else {
        //     let obj = selectedType?.filter((o) => o?.id === e?.id && o.statusFlag == "Y")
        //     if (obj?.length === 0) {
        //         selectedType?.push(modifiedData)
        //     } else {
        //         selectedType = selectedType.map((o) =>
        //             o?.id === e?.id ? modifiedData : o
        //         );
        //     }
        // }

        // // if ()
        // // xx = selectedType.find(o => o?.income?.code?.match("(I01)"))
        // // employmentIncome
        // // employmentIncome()
        // // console.log("e", e);

        // // if (e?.income?.code == 'I01' && flag) {
        let income = incomeSetup?.map(o => {
            if (o?.id === e?.id) {
                return {
                    ...o,
                    flag: flag === true ? 'Y' : 'N',
                    status: flag === true ? 'Y' : 'N',
                    statusFlag: flag === true ? 'Y' : 'N',
                    code: o?.income?.code,
                }
            } else if (o?.income?.code == "I01" && e.income?.code == "I01") {
                return {
                    ...o,
                    flag: 'N',
                    status: 'N',
                    statusFlag: 'N',
                };
            }
            return {
                ...o,
                code: o?.income?.code,
            }
        })
        income.forEach(element => {
            selectedType.push({ ...element, type: "income" })
        });
        setIncomeSetup(income);

        // } else if (e?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && flag) {
        let deduct = deductSetup?.map(o => {
            if (o?.id === e?.id) {
                return {
                    ...o,
                    flag: flag === true ? 'Y' : 'N',
                    status: flag === true ? 'Y' : 'N',
                    statusFlag: flag === true ? 'Y' : 'N',
                    code: o?.deduction?.code,
                }
            } else if (o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && e?.deduction?.code?.match("(D14|D11|D01|D13|D12)")) {
                return {
                    ...o,
                    flag: 'N',
                    status: 'N',
                    statusFlag: 'N',
                };
            }
            return {
                ...o,
                code: o?.deduction?.code
            }
        })
        deduct.forEach(element => {
            selectedType.push({ ...element, type: "deduction" })
        });
        setDeductSetup(deduct);
        setSelectedIncomeDeductType(selectedType?.filter(o => (o.status ?? o.statusFlag) == 'Y'))

    }, [selectedIncomeDeductType, incomeSetup, setIncomeSetup, deductSetup, setDeductSetup])

    const onSubmitIncomeDeductSelected = useCallback(() => {
        if (selectedIncomeDeductType?.length > 0) {
            console.log("selectedIncomeDeductType", selectedIncomeDeductType, modifiedIncomeDeduction);

            if (incomeDeductType === 'income') {
                let filterIncome = selectedIncomeDeductType?.filter(o => o.id != null && (o.type == 'income') && (o?.status == 'Y' || o?.statusFlag == 'Y')) || [];
                console.log("filterIncome", filterIncome);
                let model = filterIncome.map(o => {
                    let obj = modifiedIncomeDeduction?.incomeList?.find(o1 => o?.income?.code?.match("(I01)") && o1.income?.code?.match("(I01)") && (o1.statusFlag ?? o1.status) == 'Y')
                    console.log("obj", obj);
                    return {
                        ...o,
                        unit: obj?.unit || modifiedIncomeDeduction?.incomeList?.find(o2 => o2.id == o.id)?.unit || 0.00,
                        amount: obj?.amount || modifiedIncomeDeduction?.incomeList?.find(o2 => o2.id == o.id)?.amount || 0.00
                    }
                })

                setEmployeeIncome(model)

            } else {
                let filterDeduct = selectedIncomeDeductType?.filter((o) => o.id != null && (o.type == 'deduction') && (o?.status == 'Y' || o?.statusFlag == 'Y')) || [];
                // setEmployeeDeduct(filterDeduct)
                let deduct = filterDeduct.map(o => {
                    let obj = modifiedIncomeDeduction?.deductionList?.find(o2 => o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && o2.deduction?.code?.match("(D14|D11|D01|D13|D12)") && o2.statusFlag == 'Y')
                    console.log("obj ", obj, modifiedIncomeDeduction?.deductionList, o);
                    return {
                        ...o,
                        unit: obj?.unit || modifiedIncomeDeduction?.incomeList?.find(o2 => o2.id == o.id)?.unit || 0.00,
                        amount: obj?.amount || modifiedIncomeDeduction?.deductionList?.find(o2 => o2.id == o.id)?.amount || 0.00
                    }
                })
                setEmployeeDeduct(deduct)
            }
            setButtonState(ACTION.EDIT)
        }
        setButtonState(ACTION.PREVIEW)
        setIsModalIncomeDeductOpen(false)
        // setSelectedIncomeDeductType([])
        setIsModalOpen(true)
    }, [selectedIncomeDeductType, modifiedIncomeDeduction, incomeDeductType, modifiedIncomeDeduction])


    const previewEditIncomeDeduct = useCallback(async (values) => {
        try {
            console.log("values", values, modifiedIncomeDeduction);

            dispatch(setIsLoading(true))
            let recalFlag = null;
            let socialRecal = null;
            let incomeListId = modifiedIncomeDeduction?.incomeList?.map(o => ({
                ...o,
                incomeDeductionId: o?.income?.id,
                code: o?.income?.code,
                statusFlag: o.status ?? o.statusFlag,
                amount: Number((String(values?.incomeList?.find(o1 => o1.incomeDeductionId == o?.id)?.amount)?.replace(",", "") ?? String(o.amount)?.replace(",", ""))?.replace("undefined", "0")?.replace("null", "0") ?? 0).toFixed(2),
                unit: Number((String(values?.incomeList?.find(o1 => o1.incomeDeductionId == o?.id)?.unit)?.replace(",", "") ?? String(o.unit)?.replace(",", ""))?.replace("undefined", "0")?.replace("null", "0") ?? 0).toFixed(2),
            }))

            let deductionListId = modifiedIncomeDeduction.deductionList.map(o => {
                let oAmount = (values?.deductionList ? String(values?.deductionList?.find(o1 => o1.incomeDeductionId == o?.id)?.amount)?.replace(",", "") : String(values?.incomeList?.find(o1 => o1.incomeDeductionId == o?.id)?.amount)?.replace(",", ""))
                console.log(" o.amount", o, o?.modified, (o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") || o?.modified == 'Y'));
                console.log(" o.amount2", String(o.amount).replace(",", ""), String(oAmount).replace(",", ""));
                if ((o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") || o?.modified == 'Y') && String(o.amount).replace(",", "") != String(oAmount).replace(",", "")
                ) {
                    recalFlag = "Y"
                }
                if (o?.modified == 'Y') {
                    recalFlag = "Y"
                }
                if (o?.deduction?.code == "D02" && Number(String(o.amount).replace(",", "")).toFixed(2) != Number(String(oAmount).replace(",", "")).toFixed(2)) {
                    socialRecal = "Y"
                }
                return {
                    ...o,
                    incomeDeductionId: o?.deduction?.id,
                    code: o.deduction.code,
                    statusFlag: o.status ?? o.statusFlag,
                    amount: Number(String(oAmount).replace(",", "")).toFixed(2) ?? Number(String(o.amount).replace(",", "")).toFixed(2),
                }
            })

            console.log("modifiedIncomeDeduction", modifiedIncomeDeduction);

            values?.incomeList?.filter(o => o.ot == 'Y' && !modifiedIncomeDeduction.incomeList.some(o1 => o1.id == o.incomeDeductionId)).forEach(o => {
                console.log("incomeSetup", incomeSetup, o);
                recalFlag = null;
                let o1 = incomeSetup.find(o1 => o1.id == o.incomeDeductionId)
                incomeListId.push({
                    ...o1,
                    amount: Number(String(o.amount)?.replace(",", "")?.replace("undefined", "0")?.replace("null", "0") ?? 0).toFixed(2),
                    unit: String(o.unit)?.replace(",", "")?.replace("undefined", "0")?.replace("null", "0") ?? 0,
                    status: 'Y',
                    incomeDeductionId: o1?.income?.id,
                    code: o1?.income?.code,
                    statusFlag: 'Y',
                })
            }
            )
            console.log("values?.incomeList?.filter(o=>o.ot=='Y')", incomeListId);

            try {
                const response = await service.previewEditEmployeeIncomeDeductInPeriod({
                    txnPaymentId: currentTxnPayment?.txnPaymentId,
                    companyId: currentCompany,
                    employeeId: currentTxnPayment?.employeeId,
                    actionId: currentEmployee,
                    editingTax: editingTax,
                    txnPayrollPeriodId: payrollPeriodId,
                    incomeListId,
                    deductionListId,
                    recalFlag,
                    socialRecal
                })

                if (response?.data?.content) {
                    response.data.content.incomes = response.data?.content.income
                    response.data.content.deductions = response.data?.content.deduction
                }

                dispatch(setEmployeeIncomeDeduction(response?.data?.content))

            } catch (error) {
                console.log("error", error);
            }

            // setEmployeeIncome(response?.data?.content?.incomes)
            // setEmployeeDeduct(response?.data?.content?.deductions)

        } catch (error) {
            console.log("error2", error);
        } finally {
            dispatch(setIsLoading(false))
            setButtonState(ACTION.EDIT)
        }
    }, [currentCompany, currentEmployee, currentTxnPayment, editingTax, modifiedIncomeDeduction, payrollPeriodId, onSubmitIncomeDeductSelected])

    const onSubmit = useCallback(async (values, fn = () => { }) => {
        if (buttonState === ACTION.EDIT) {
            const confirmMessage = i18n.language === 'th'
                ? "หากแก้ไขข้อมูล แล้วไม่ได้มีการส่งขออนุมัติ ข้อมูลที่แก้ไขจะถูกคำนวณใหม่"
                : "If you edit information And there was no request for approval. The edited data will be recalculated.";
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {confirmMessage}
                        </p>
                    </>
                ),
                onOk() {
                    if (values) {
                        switch (buttonState) {
                            // case ACTION.PREVIEW:
                            //     previewEditIncomeDeduct(values)
                            //     break;
                            case ACTION.EDIT:

                                updateTxnPaymentEmployeeIncomeDeduct(values)
                                fn?.()

                                break;
                            default:
                                break;
                        }
                    }
                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase(),
                // okText: "CONFIRM",
                // cancelText: "CANCEL",
            });
        } else if (buttonState === ACTION.PREVIEW) {
            console.log("manna preview");

            previewEditIncomeDeduct(values)
        }


    }, [buttonState, i18n.language, previewEditIncomeDeduct, t, updateTxnPaymentEmployeeIncomeDeduct])

    // * fix
    const getEmploymentIncomeDeductionTypeModal = useCallback(() => {
        return <IncomeDeductionSetupModal
            type={incomeDeductType}
            isModalIncomeDeductOpen={isModalIncomeDeductOpen}
            employmentIncome={incomeSetup}
            employmentDeduct={deductSetup}
            setIsModalIncomeDeductOpen={setIsModalIncomeDeductOpen}
            onCancelIncomeDeductType={onCancelIncomeDeductType}
            onIncomeDeductTypeSelected={onIncomeDeductTypeSelected}
            onSubmitIncomeDeductSelected={onSubmitIncomeDeductSelected}
        />

    }, [
        isModalIncomeDeductOpen,
        employmentDeduct,
        employmentIncome,
        incomeSetup,
        deductSetup,
        incomeDeductType,
        onCancelIncomeDeductType,
        onIncomeDeductTypeSelected])

    const onEditIncomeDeductType = useCallback(async (incomeOrDeduct) => {
        setIncomeDeductType(incomeOrDeduct)
        // await getEmployeeIncomeDeductForSetup(incomeOrDeduct)
        if (incomeOrDeduct === 'income') {
            setSelectedIncomeDeductType(employeeIncome)
        } else {
            setSelectedIncomeDeductType(employeeDeduct)
        }
        setIsModalIncomeDeductOpen(true);
    }, [getEmploymentTypeIncomeDeductForSetup, employeeIncome, employeeDeduct])

    const onBack = useCallback(async () => {
        // getDefultIncomeDeduct()
        setButtonState(ACTION.PREVIEW)
        onSubmitIncomeDeductSelected()

    }, [onSubmitIncomeDeductSelected])

    const getModal = useMemo(() => {

        switch (action) {
            case ACTION.VIEW:
                return <PaymentModal
                    isModalOpen={isModalOpen}
                    onCancel={onCancel}
                    employee={modifiedIncomeDeduction}
                    previewEditIncomeDeduct={previewEditIncomeDeduct}
                    onFinish={onSubmit}
                    getOvertimeInPeriod={getOvertimeInPeriod}
                    onResetList={onConfirmReset}
                    incomeSetup={incomeSetup}
                    onBack={onBack}
                    step={payrollPeriod?.step}
                    action={action}
                    handleIncomeDeductType={onEditIncomeDeductType}
                    form={form}
                    setEditingTax={setEditingTax}
                    currentTxnPayment={currentTxnPayment}
                />
            case ACTION.EDIT:
                return <PaymentModal
                    isModalOpen={isModalOpen}
                    onCancel={onCancel}
                    employee={modifiedIncomeDeduction}
                    onFinish={onSubmit}
                    previewEditIncomeDeduct={previewEditIncomeDeduct}
                    getOvertimeInPeriod={getOvertimeInPeriod}
                    incomeSetup={incomeSetup}
                    onBack={onBack}
                    onResetList={onConfirmReset}
                    step={payrollPeriod?.step}
                    action={action}
                    handleIncomeDeductType={onEditIncomeDeductType}
                    form={form}
                    setEditingTax={setEditingTax}
                    currentTxnPayment={currentTxnPayment}
                />
            case ACTION.EDIT_PAYROLL:
                return <PayrollModal
                    payrollPeriod={payrollPeriod}
                    isModalOpen={isModalOpen}
                    onCancel={onCancel}
                    onBack={onBack}
                    onFinish={onSubmitEditPayroll}
                    action={action}
                    form={form}
                />

            default:
                return;
        }
    }, [action, isModalOpen, form, incomeSetup, payrollPeriod, getOvertimeInPeriod, onSubmit, onSubmitEditPayroll, onEditIncomeDeductType, modifiedIncomeDeduction, onResetList])


    const onRejected = useCallback(async () => {
        try {
            await service.rejectedPayment({
                txnPayrollPeriodId: payrollPeriodId,
                txnPaymentIds: rowSelected,
                actionId: currentEmployee,
                employeeId: currentEmployee,
                companyId: currentCompany,
            })
            await getPayrollPeriod(payrollPeriodId)
            await getEmployeeList({ page: 0, size: 10 })
            onClearSelected()
        } catch (error) {

        } finally {

        }
    }, [currentEmployee, currentCompany, getPayrollPeriod, getEmployeeList, rowSelected])

    const updateHeaderStatusToVerification = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateHeaderStatusToVerification({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            if (response?.data?.content?.description) {
                Modal.error({
                    content: (response?.data?.content?.description), onOk: () => {
                        getPayrollPeriod(payrollPeriodId)
                        setIsModalOpen(false)
                    }, okText: t("confirm")
                })
            } else {
                getPayrollPeriod(payrollPeriodId)
                setIsModalOpen(false)
                onClearSelected()
                getEmployeeList({ page: 0, size: 10 })
                getCountTxnPaymentByStatus()
            }


        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getPayrollPeriod, getEmployeeList, getCountTxnPaymentByStatus])

    const updateHeaderStatusToApproval = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateHeaderStatusToApproval({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            if (response?.data?.content?.description) {
                Modal.error({
                    content: (response?.data?.content?.description), onOk: () => {
                        getPayrollPeriod(payrollPeriodId)
                        setIsModalOpen(false)
                    }, okText: t("confirm")
                })
            } else {
                getPayrollPeriod(payrollPeriodId)
                getCountTxnPaymentByStatus()
                getTotalEmployeeTab()
                setIsModalOpen(false)
                onClearSelected()
                getEmployeeList({ page: 0, size: 10 })
                // getCountTxnPaymentByStatus()
            }

        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList, getPayrollPeriod,
        getCountTxnPaymentByStatus])
    const updateTxnPaymentStatusToReject = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            await service.updateStatusToReject({
                ...values,
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                txnPaymentIds: rowSelected,
            });
            onClearSelected()
            getPayrollPeriod(payrollPeriodId)
            getCountTxnPaymentByStatus()
            getTotalEmployeeTab()
            getEmployeeList({ page: 0, size: 10 })

        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
            setIsModalRejectReasonOpen(false)
        }
    }, [currentCompany, currentEmployee, rowSelected, getPayrollPeriod,
        getCountTxnPaymentByStatus,
        getTotalEmployeeTab,
        getEmployeeList])

    const updateHeaderStatusToCal = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const res = await updateTxnPaymentStatusToReject?.();
            const response = await service.updateHeaderStatusToCal({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            if (response?.data?.content?.description) {
                Modal.error({
                    content: (response?.data?.content?.description), onOk: () => {
                        getPayrollPeriod(payrollPeriodId)
                        setIsModalOpen(false)
                    }, okText: t("confirm")
                })
            } else {
                getPayrollPeriod(payrollPeriodId)
                getCountTxnPaymentByStatus()
                getTotalEmployeeTab()
                setIsModalOpen(false)
                // onClearSelected()
                getEmployeeList({ page: 0, size: 10 })
                // getCountTxnPaymentByStatus()
            }

        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList, getPayrollPeriod,
        getCountTxnPaymentByStatus, updateTxnPaymentStatusToReject])

    const updateHeaderStatusToClose = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateHeaderStatusToClose({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            await getPayrollPeriod(payrollPeriodId)
            getEmployeeList({ page: 0, size: 10 })
            setIsModalOpen(false).
                onClearSelected()
            // getCountTxnPaymentByStatus()
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList, getPayrollPeriod,
        getCountTxnPaymentByStatus])

    const updateHeaderStatusToPayment = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateHeaderStatusToPayment({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            getPayrollPeriod(payrollPeriodId)
            getEmployeeList({ page: 0, size: 10 })
            onClearSelected()
            setIsModalOpen(false)
            // getCountTxnPaymentByStatus()
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList, getCountTxnPaymentByStatus, getPayrollPeriod])

    const updateTxnPayrollPeriodHeaderStatusToPaid = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateHeaderStatusToPaid({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            });
            getPayrollPeriod(payrollPeriodId)
            onClearSelected()
            setIsModalOpen(false)
            getEmployeeList({ page: 0, size: 10 })
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList])



    const updateTxnPaymentStatusToPending = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))

            const response = await service.updateStatusToPending({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                txnPaymentIds: rowSelected
            });
            getPayrollPeriod(payrollPeriodId)
            getTotalEmployeeTab();
            getCountTxnPaymentByStatus()

            getEmployeeList({ page: 0, size: 10 })
            setIsModalOpen(false)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, rowSelected, getEmployeeList, getTotalEmployeeTab, getPayrollPeriod, getCountTxnPaymentByStatus])

    const updateTxnPaymentStatusToCalculate = useCallback(async (cb = async () => { }) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.updateStatusToCalculate({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
                txnPaymentIds: rowSelected
            });
            getPayrollPeriod(payrollPeriodId)
            getCountTxnPaymentByStatus()
            getTotalEmployeeTab()
            getEmployeeList({ page: 0, size: 10 })
            setIsModalOpen(false)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, rowSelected, getPayrollPeriod,
        getCountTxnPaymentByStatus,
        getTotalEmployeeTab,
        getEmployeeList])


    const getButtonByStep = useCallback((e) => {

        if (payrollPeriod?.step == 0 && (tab == "employeeIn" || tab == "employeeOut" || tab == 'incompleteData')) {
            return <Button
                disabled={selectedRowKeys.length == 0}
                type="primary"
                htmlType="submit"
                onClick={async () => {
                    let res = await createPaymentByEmployeeIds(payrollPeriodId, selectedRowKeys)
                    getPayrollPeriod(payrollPeriodId)
                    getEmployeeList({ page: 0, size: 10 })
                    getTotalEmployeeTab()
                    getCountTxnPaymentByStatus()
                }}
            >
                {t('payment.label.toCalPayroll')}
            </Button>
        }
        if (payrollPeriod?.step == 0 && pageByStep == 0) {
            return (
                <Button
                    type="primary"
                    htmlType="submit"
                    disabled={totalEmployeeTab?.countIncomplete > 0}
                    onClick={() => {
                        Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                                <>
                                    <p>
                                        {t("payment.label.verify-salary")}
                                    </p>
                                </>
                            ),
                            onOk() {
                                updateHeaderStatusToVerification()

                            },
                            okText: t("common.confirm").toUpperCase(),
                            cancelText: t("common.cancel").toUpperCase(),
                        });
                    }}
                    style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                >
                    {t("payment.label.verify-salary")}
                </Button>

            )
        }
        if (payrollPeriod?.step == 1 && pageByStep == 2) {
            return (<Flex gap="5px">
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                        Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                                <>
                                    <p>
                                        {t("payment.label.send-request-for-approve")}
                                    </p>
                                </>
                            ),
                            onOk() {
                                updateHeaderStatusToCal()

                            },
                            okText: t("common.confirm").toUpperCase(),
                            cancelText: t("common.cancel").toUpperCase(),
                        });
                    }}
                >
                    {t("payment.label.send-request-for-approve")}
                </Button>
                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => {

                        Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                                <>
                                    <p>
                                        {t("payment.label.return-payroll")}
                                    </p>
                                </>
                            ),
                            onOk() {
                                returnPayment()
                            },
                            okText: t("common.confirm").toUpperCase(),
                            cancelText: t("common.cancel").toUpperCase(),
                        });
                    }}
                >
                    {t("payment.label.return-payroll")}
                </Button>

                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                        Modal.confirm({
                            title: t("dialog.confirmation.header"),
                            content: (
                                <>
                                    <p>
                                        {t("payment.label.send-request-for-approve")}
                                    </p>
                                </>
                            ),
                            onOk() {
                                updateHeaderStatusToApproval()

                            },
                            okText: t("common.confirm").toUpperCase(),
                            cancelText: t("common.cancel").toUpperCase(),
                        });
                    }}
                >
                    {t("payment.label.send-request-for-approve")}
                </Button>
            </Flex>)
        }
        if (payrollPeriod?.step == 2 && pageByStep == 3) {
            return (
                <Flex gap="5px">
                    <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                            Modal.confirm({
                                title: t("dialog.confirmation.header"),
                                content: (
                                    <>
                                        <p>
                                            {t("payment.label.return-payroll")}
                                        </p>
                                    </>
                                ),
                                onOk() {
                                    returnPayment()
                                },
                                okText: t("common.confirm").toUpperCase(),
                                cancelText: t("common.cancel").toUpperCase(),
                            });
                        }}
                    >
                        {t("payment.label.return-payroll")}
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                            Modal.confirm({
                                title: t("dialog.confirmation.header"),
                                content: (
                                    <>
                                        <p>
                                            {t("payment.label.approve")}
                                        </p>
                                    </>
                                ),
                                onOk() {
                                    updateHeaderStatusToClose()
                                },
                                okText: t("common.confirm").toUpperCase(),
                                cancelText: t("common.cancel").toUpperCase(),
                            });
                        }}
                    >
                        {t("payment.label.approve")}
                    </Button>
                </Flex>
            )
        }
        if (payrollPeriod?.step == 3 && pageByStep == 4) {
            return <Button
                type="primary"
                htmlType="submit"
                onClick={() => {
                    Modal.confirm({
                        title: t("dialog.confirmation.header"),
                        content: (
                            <>
                                <p>
                                    {t('payment.label.step.close')}
                                </p>
                            </>
                        ),
                        onOk() {
                            updateHeaderStatusToPayment()
                        },
                        okText: t("common.confirm").toUpperCase(),
                        cancelText: t("common.cancel").toUpperCase(),
                    });
                }}
            >
                {t('payment.label.step.close')}
            </Button>
        }
        if (payrollPeriod?.step == 4 && pageByStep == 5) {
            return <Button
                type="primary"
                htmlType="submit"
                onClick={() => {
                    Modal.confirm({
                        title: t("dialog.confirmation.header"),
                        content: (
                            <>
                                <p>
                                    นำส่งธนาคาร
                                </p>
                            </>
                        ),
                        onOk() {
                            // updateStatus("PAID")

                            // * sending to bank
                        },
                        okText: t("common.confirm").toUpperCase(),
                        cancelText: t("common.cancel").toUpperCase(),
                    });
                }}
            >
                นำส่งธนาคาร
            </Button>
        }

        switch (payrollPeriod?.step) {
            // case 0:
            //     return (
            //         <Button
            //             type="primary"
            //             htmlType="submit"
            //             disabled={totalEmployeeTab?.countIncomplete > 0}
            //             onClick={() => {
            //                 Modal.confirm({
            //                     title: t("dialog.confirmation.header"),
            //                     content: (
            //                         <>
            //                             <p>
            //                                 {t("payment.label.verify-salary")}
            //                             </p>
            //                         </>
            //                     ),
            //                     onOk() {
            //                         updateHeaderStatusToVerification()

            //                     },
            //                     okText: t("common.confirm").toUpperCase(),
            //                     cancelText: t("common.cancel").toUpperCase(),
            //                 });
            //             }}
            //             style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
            //         >
            //             {t("payment.label.verify-salary")}
            //         </Button>

            //     )
            // case 1:
            //     return (<Flex gap="5px">
            //         <Button
            //             type="primary"
            //             htmlType="submit"
            //             onClick={() => {

            //                 Modal.confirm({
            //                     title: t("dialog.confirmation.header"),
            //                     content: (
            //                         <>
            //                             <p>
            //                                 {t("payment.label.return-payroll")}
            //                             </p>
            //                         </>
            //                     ),
            //                     onOk() {
            //                         returnPayment()
            //                     },
            //                     okText: t("common.confirm").toUpperCase(),
            //                     cancelText: t("common.cancel").toUpperCase(),
            //                 });
            //             }}
            //         >
            //             {t("payment.label.return-payroll")}
            //         </Button>
            //         <Button
            //             type="primary"
            //             htmlType="submit"
            //             onClick={() => {
            //                 Modal.confirm({
            //                     title: t("dialog.confirmation.header"),
            //                     content: (
            //                         <>
            //                             <p>
            //                                 {t("payment.label.send-request-for-approve")}
            //                             </p>
            //                         </>
            //                     ),
            //                     onOk() {
            //                         updateHeaderStatusToApproval()

            //                     },
            //                     okText: t("common.confirm").toUpperCase(),
            //                     cancelText: t("common.cancel").toUpperCase(),
            //                 });
            //             }}
            //         >
            //             {t("payment.label.send-request-for-approve")}
            //         </Button>
            //     </Flex>)
            // case 2:
            //     return (
            //         <Flex gap="5px">
            //             <Button
            //                 type="primary"
            //                 htmlType="submit"
            //                 onClick={() => {
            //                     Modal.confirm({
            //                         title: t("dialog.confirmation.header"),
            //                         content: (
            //                             <>
            //                                 <p>
            //                                     {t("payment.label.return-payroll")}
            //                                 </p>
            //                             </>
            //                         ),
            //                         onOk() {
            //                             returnPayment()
            //                         },
            //                         okText: t("common.confirm").toUpperCase(),
            //                         cancelText: t("common.cancel").toUpperCase(),
            //                     });
            //                 }}
            //             >
            //                 {t("payment.label.return-payroll")}
            //             </Button>
            //             <Button
            //                 type="primary"
            //                 htmlType="submit"
            //                 onClick={() => {
            //                     Modal.confirm({
            //                         title: t("dialog.confirmation.header"),
            //                         content: (
            //                             <>
            //                                 <p>
            //                                     {t("payment.label.approve")}
            //                                 </p>
            //                             </>
            //                         ),
            //                         onOk() {
            //                             updateHeaderStatusToClose()
            //                         },
            //                         okText: t("common.confirm").toUpperCase(),
            //                         cancelText: t("common.cancel").toUpperCase(),
            //                     });
            //                 }}
            //             >
            //                 {t("payment.label.approve")}
            //             </Button>
            //         </Flex>
            //     )
            // case 3:
            //     return <Button
            //         type="primary"
            //         htmlType="submit"
            //         onClick={() => {
            //             Modal.confirm({
            //                 title: t("dialog.confirmation.header"),
            //                 content: (
            //                     <>
            //                         <p>
            //                             {t('payment.label.step.close')}
            //                         </p>
            //                     </>
            //                 ),
            //                 onOk() {
            //                     updateHeaderStatusToPayment()
            //                 },
            //                 okText: t("common.confirm").toUpperCase(),
            //                 cancelText: t("common.cancel").toUpperCase(),
            //             });
            //         }}
            //     >
            //         {t('payment.label.step.close')}
            //     </Button>
            // case 4:
            //     return <Button
            //         type="primary"
            //         htmlType="submit"
            //         onClick={() => {
            //             Modal.confirm({
            //                 title: t("dialog.confirmation.header"),
            //                 content: (
            //                     <>
            //                         <p>
            //                             นำส่งธนาคาร
            //                         </p>
            //                     </>
            //                 ),
            //                 onOk() {
            //                     // updateStatus("PAID")

            //                     // * sending to bank
            //                 },
            //                 okText: t("common.confirm").toUpperCase(),
            //                 cancelText: t("common.cancel").toUpperCase(),
            //             });
            //         }}
            //     >
            //         นำส่งธนาคาร
            //     </Button>
            default:
                return <div></div>
        }

    }, [employeeList, currentCompany, currentEmployee, payrollPeriod?.step, tab, payrollPeriod?.statusName, getEmployeeList, getTotalEmployeeTab, getCountTxnPaymentByStatus, selectedRowKeys, pageByStep, updateHeaderStatusToCal])

    const getEmployeeIncomeDeductionByTxnPaymentIdFn = useCallback(async (values) => {

        try {
            dispatch(setIsLoading(true))
            const response = await service.getEmployeeIncomeDeductionByTxnPaymentId({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPaymentId: values?.txnPaymentId,
            })

            const response2 = await service.getStpEmployeeIncomeDeductionByEmployeeId({
                companyId: currentCompany,
                employeeId: values?.employeeId,
                actionId: currentEmployee,
            })
            // console.log("response2", values, response2, response);
            // console.log("response2.data?.content", response2.data?.content);

            let income2 = response2.data?.content?.income || []
            let deduction2 = response2.data?.content?.deduction || []

            response.data.content.incomes = response?.data?.content.incomes.map?.(o => ({
                ...o,
                modified: income2.find(o1 => o1.id == o.id)?.modified
            }))
            response.data.content.deductions = response?.data?.content.deductions.map?.(o => ({
                ...o,
                modified: deduction2.find(o1 => o1.id == o.id)?.modified
            }))

            // console.log('222', response?.data?.content.map(o => ({
            //     ...o,
            //     // modified: response2.find(o1 => o1.id == o.id)?.modified,
            //     incomes: o.incomes?.map?.(o1 => ({
            //         ...o1,
            //         modified: income2.find(o1 => o1.id == o.id)?.modified
            //     })),
            //     deductions: o.deduction?.map?.(o1 => ({
            //         ...o1,
            //         modified: deduction2.find(o1 => o1.id == o.id)?.modified
            //     }))
            // })));

            dispatch(setEmployeeIncomeDeduction(response?.data?.content))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    // * p' ice
    const getStpEmployeeIncomeDeductionByEmpId = useCallback(async (values) => {

        try {
            dispatch(setIsLoading(true))
            const response = await service.getStpEmployeeIncomeDeductionByEmployeeId({
                companyId: currentCompany,
                employeeId: values?.employeeId,
                actionId: currentEmployee,
            })
            dispatch(setEmployeeIncomeDeductionDefalut(response?.data?.content))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const getEmploymentIncomeDeductionByTxnPayrollPeriodIdFn = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.getEmploymentIncomeDeductionByPayrollId({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            })
            dispatch(setEmploymentIncomeDeduction(response?.data?.content))

        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const sendSalaryCertificateFn = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.sendingSalaryCertificate({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            })
            dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            getEmployeeList({ page: 0, size: 10 })
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList])
    const sendingSalaryCertificateByIdFn = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.sendingSalaryCertificateById({
                companyId: currentCompany,
                employeeId: currentEmployee,
                empId: record.employeeId,
                actionId: currentEmployee,
                txnPayrollPeriodId: payrollPeriodId,
            })
            dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            getEmployeeList({ page: 0, size: 10 })
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getEmployeeList])

    const getReport = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const employmentType = payrollPeriod?.employmentType?.[0]?.type;
            const monthYear = payrollPeriod?.employmentType?.[0]?.monthYear;

            await service.exportPayment({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                payrollPeriodId: payrollPeriodId,
            }).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Payroll ${employmentType} report ${monthYear}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, payrollPeriod, dispatch])


    const getReportBBL = useCallback(async () => {
        try {

            dispatch(setIsLoading(true))
            const employmentType = payrollPeriod?.employmentType?.[0]?.type;
            const monthYear = payrollPeriod?.employmentType?.[0]?.monthYear;

            await service.exportPaymentBBL({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                payrollPeriodId: payrollPeriodId,
            }).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Payroll ${employmentType} report ${monthYear}_BBL.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, payrollPeriod, dispatch])

    const exportTextFileBank = useCallback(async () => {
        try {
            dispatch(setIsTextFileLoading(true))

            await service.exportTextFile({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                payrollPeriodId: payrollPeriodId,
            }).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `TextFile.txt`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsTextFileLoading(false))
        }
    }, [currentCompany, currentEmployee, dispatch, payrollPeriodId])


    const getCompany = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            const response = await service.getCompany({
                requestId: generateRandomString(),
                companyId: currentCompany,
            });
            setCompany(response.data);
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, setCompany]);



    const onView = useCallback(async (id) => {
        setAction(ACTION.VIEW)
        setCurrentTxnPayment(id)
        await getEmployeeIncomeDeductionByTxnPaymentIdFn(id)
        setIsModalOpen(true)
    }, [getEmployeeIncomeDeductionByTxnPaymentIdFn])

    const previewPaySlip = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            console.log("currentTxnPayment", values, values?.txnPaymentId);

            const response = await previewPaySlipById({
                txnPaymentId: values?.txnPaymentId,

            })

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const modal = document.createElement('div');
            modal.style.position = 'fixed';
            modal.style.top = '0';
            modal.style.left = '0';
            modal.style.width = '100%';
            modal.style.height = '100%';
            modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            modal.style.display = 'flex';
            modal.style.alignItems = 'center';
            modal.style.justifyContent = 'center';
            modal.style.zIndex = '9999';

            const iframe = document.createElement('iframe');
            iframe.style.width = '80%';
            iframe.style.height = '80vh';
            iframe.src = url;

            const closeButton = document.createElement('button');
            closeButton.textContent = 'Close';
            closeButton.style.position = 'absolute';
            closeButton.style.top = '20px';
            closeButton.style.right = '20px';
            closeButton.style.padding = '10px 20px';
            closeButton.style.backgroundColor = '#ff0000';
            closeButton.style.color = '#fff';
            closeButton.style.border = 'none';
            closeButton.style.borderRadius = '5px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.fontSize = '16px';

            closeButton.addEventListener('click', () => {
                document.body.removeChild(modal);
                window.URL.revokeObjectURL(url);
            });

            modal.appendChild(iframe);
            modal.appendChild(closeButton);

            document.body.appendChild(modal);


        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentTxnPayment])

    const onViewSlip = useCallback(async (record) => {
        previewPaySlip(record)
    }, [previewPaySlip, currentTxnPayment])

    const onEdit = useCallback(async (record) => {
        setAction(ACTION.EDIT)
        setCurrentTxnPayment(record)
        await getStpEmployeeIncomeDeductionByEmpId(record);
        await getEmployeeIncomeDeductionByTxnPaymentIdFn(record)
        setIsModalOpen(true)
    }, [isModalOpen, getEmploymentTypeIncomeDeductForSetup, getEmployeeIncomeDeductionByTxnPaymentIdFn])

    const downloadPaySlip = useCallback(async (values) => {
        setIsSlipDownload(true);
        try {
            const baseRequest = {
                txnPaymentId: values?.txnPaymentId,
            }
            dispatch(setIsLoading(true))
            await service.exportPaySlipByTxnPaymentId(baseRequest).then(res => {
                const url = window.URL.createObjectURL(res?.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "employee-pay-slip.pdf");
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
            setIsSlipDownload(false);
        }
    }, [currentEmployee, dispatch, payrollPeriodId])

    const onDownloadSlip = useCallback(async (record) => {
        downloadPaySlip(record)
    }, [downloadPaySlip, currentTxnPayment])

    const transferStatus = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            await service.transfersToTemp({
                txnPayrollPeriodId: values.txnPaymentId,
            })


            getPayrollPeriod(payrollPeriodId)
            getEmployeeList({ page: 0, size: 10 })
            getTotalEmployeeTab()
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [getTotalEmployeeTab, getPayrollPeriod, getEmployeeList])

    const onTranfers = useCallback(async (record) => {
        const confirmMessage = i18n.language === 'th'
            ? "จะทำการส่งข้อมูลกลับไปที่ ข้อมูลไม่ครบ"
            : "The data will be sent back, but it is incomplete.";
        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: (
                <>
                    <p>
                        {confirmMessage}
                    </p>
                </>
            ),
            onOk() {
                if (record) {
                    console.log("info ", record);
                    transferStatus(record)
                }
            },
            okText: t("common.confirm").toUpperCase(),
            cancelText: t("common.cancel").toUpperCase(),
        });
    }, [isModalOpen, transferStatus, getEmploymentTypeIncomeDeductForSetup, getEmployeeIncomeDeductionByTxnPaymentIdFn])



    const updateStatus = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            await service.updateStatus({
                txnPayrollPeriodId: payrollPeriodId,
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                status: values
            })
            getPayrollPeriod(payrollPeriodId)
            getEmployeeList({ page: 0, size: 10 })
            getTotalEmployeeTab()
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, payrollPeriod, payrollPeriodId, getEmployeeList])




    const toParams = useCallback((params) => {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            ...params,
            page: pagination.page || 0,
            size: pagination.pageSize || 10,
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;

    }, [])

    const onEditPayroll = useCallback((values) => {
        setIsModalOpen(true)
        setAction(ACTION.EDIT_PAYROLL)
    }, [])

    const onPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];

            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination?.current - 1,
                    size: tablePagination?.pageSize,
                    pageSize: tablePagination?.pageSize,
                    current: tablePagination.current - 1,
                },
                searchTxt: searchTxt?.searchTxt,
                sortBy: modifiedSorter,
                exportStatus: exportStatus
            });
            getEmployeeList(modifiedParams);
        },
        [getEmployeeList, searchTxt, tab, exportStatus]
    );

    function getVisibleIcon() {
        return visible
            ? <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}
                icon={<EyeHideIcon />}
                onClick={() => setVisible(false)} />
            : <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}
                icon={<EyeIcon />}
                onClick={() => setVisible(true)} />
    }

    const getRejectReasonModal = useCallback(() => {
        return <RejectReasonModal
            isModalOpen={isModalRejectReasonOpen}
            onSubmit={updateTxnPaymentStatusToReject}
            onRejectModalClose={onRejectModalClose}
        />
    }, [isLoading, isModalRejectReasonOpen, updateTxnPaymentStatusToReject])

    const getCalculateTable = useCallback(() => {
        setExportStatus()
        switch (tab) {
            case PAYMENT_TAB[0].key:
                return <PaymentTable
                    dataSource={employeeList}
                    onView={onView}
                    onEdit={onEdit}
                    onChange={onPageChange}
                    onTranfers={onTranfers}
                    tabKey={PAYMENT_TAB[0].key}
                    pagination={pagination}
                    step={payrollPeriod?.step}
                    payrollPeriod={payrollPeriod}
                    getButtonByStep={getButtonByStep}
                    isLoading={isLoading}
                    visible={visible}
                    rowSelection={pageStatus !== '0' ? rowSelection : false}
                    rowSelected={rowSelected}
                    onRejected={onRejected}
                />

            case PAYMENT_TAB[1].key:
                return <EmployeeIncompleteTable
                    dataSource={incompleteList}
                    onView={onView}
                    onEdit={onEdit}
                    tabKey={PAYMENT_TAB[1].key}
                    onChange={onPageChange}
                    pagination={pagination}
                    step={payrollPeriod?.step}
                    getButtonByStep={getButtonByStep}
                    isLoading={isLoading}
                    visible={visible}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                />
            case PAYMENT_TAB[2].key:
                return <EmployeeIncompleteTable
                    dataSource={newEmployeeList}
                    onView={onView}
                    onEdit={onEdit}
                    tabKey={PAYMENT_TAB[1].key}
                    onChange={onPageChange}
                    pagination={pagination}
                    step={payrollPeriod?.step}
                    getButtonByStep={getButtonByStep}
                    isLoading={isLoading}
                    visible={visible}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                />

            case PAYMENT_TAB[3].key:
                return <EmployeeIncompleteTable
                    dataSource={resignList}
                    onView={onView}
                    onEdit={onEdit}
                    tabKey={PAYMENT_TAB[1].key}
                    onChange={onPageChange}
                    pagination={pagination}
                    step={payrollPeriod?.step}
                    getButtonByStep={getButtonByStep}
                    isLoading={isLoading}
                    visible={visible}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                />
            case PAYMENT_TAB[4].key:
                return <PaymentTable
                />
            default:
                return <EmployeeIncompleteTable
                    dataSource={employeeList}
                    onView={onView}
                    onEdit={onEdit}
                    onChange={onPageChange}
                    pagination={pagination}
                    tabKey={tab}
                    step={payrollPeriod?.step}
                    getButtonByStep={getButtonByStep}
                    isLoading={isLoading}
                    visible={visible}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys}
                />
        }
    }, [tab, employeeList, incompleteList, resignList, newEmployeeList,
        pagination, isLoading, visible, selectedRowKeys, action, rowSelection,
        rowSelected, pageByStep, pageStatus, payrollPeriod,
        getButtonByStep, onRejected, getEmployeeIncomeDeductionByTxnPaymentIdFn])


    const getVerificationTable = useCallback(() => {

        return <VerificationTable
            dataSource={employeeList}
            onView={onView}
            onEdit={onEdit}
            onViewSlip={onViewSlip}
            onChange={onPageChange}
            sendingSalaryCertificateByIdFn={sendingSalaryCertificateByIdFn}
            tabKey={PAYMENT_TAB[0].key}
            pagination={pagination}
            step={payrollPeriod?.step}
            getButtonByStep={getButtonByStep}
            isLoading={isLoading}
            visible={visible}
            rowSelection={payrollPeriod?.step === 1 ? rowSelection : false}
            rowSelected={rowSelected}
            onRejected={onRejected}
            pageStatus={pageStatus}
            onDownloadSlip={onDownloadSlip}
        />
    }, [employeeList,
        onView,
        onEdit,
        onPageChange,
        onViewSlip,
        PAYMENT_TAB,
        pagination,
        payrollPeriod,
        getButtonByStep,
        isLoading,
        visible,
        rowSelection,
        pageByStep,
        pageStatus,
        rowSelected,
        sendingSalaryCertificateByIdFn,
        onRejected,
        onDownloadSlip])

    const getApprovalTable = useCallback(() => {
        return <ApprovalTable
            dataSource={employeeList}
            onView={onView}
            onEdit={onEdit}
            onChange={onPageChange}
            tabKey={PAYMENT_TAB[0].key}
            pagination={pagination}
            step={payrollPeriod?.step}
            getButtonByStep={getButtonByStep}
            isLoading={isLoading}
            visible={visible}
            rowSelection={payrollPeriod?.step === 2 ? rowSelection : false}
            rowSelected={rowSelected}
            onRejected={onRejected}
        />
    }, [employeeList,
        onView,
        onEdit,
        onPageChange,
        PAYMENT_TAB,
        pagination,
        payrollPeriod,
        getButtonByStep,
        isLoading,
        visible,
        pageByStep,
        rowSelection,
        rowSelected,
        onRejected])

    const getCloseTable = useCallback(() => {
        return <CloseTable
            dataSource={employeeList}
            onView={onView}
            onEdit={onEdit}
            onChange={onPageChange}
            tabKey={PAYMENT_TAB[0].key}
            pagination={pagination}
            step={payrollPeriod?.step}
            getButtonByStep={getButtonByStep}
            isLoading={isLoading}
            visible={visible}
            rowSelection={false}
            // rowSelected={rowSelected}
            onRejected={onRejected}
        />
    }, [employeeList,
        onView,
        onEdit,
        onPageChange,
        PAYMENT_TAB,
        pagination,
        payrollPeriod,
        getButtonByStep,
        isLoading,
        visible,
        pageByStep,
        rowSelection,
        rowSelected,
        onRejected])

    const getPaymentTable = useCallback(() => {
        return <PaymentTable
            dataSource={employeeList}
            onView={onView}
            onEdit={onEdit}
            onChange={onPageChange}
            tabKey={PAYMENT_TAB[0].key}
            pagination={pagination}
            step={payrollPeriod?.step}
            getButtonByStep={getButtonByStep}
            isLoading={isLoading}
            visible={visible}
            rowSelection={false}
            // rowSelected={rowSelected}
            onRejected={onRejected}
        />
    }, [employeeList,
        onView,
        onEdit,
        onPageChange,
        PAYMENT_TAB,
        pagination,
        payrollPeriod,
        getButtonByStep,
        isLoading,
        visible,
        pageByStep,
        rowSelection,
        rowSelected,
        onRejected])

    // async function callByGroup(params) {
    //     let status = pageStatus;
    //     let response = await service.getEmployeeGroupCalculationInfo({
    //         companyId: currentCompany,
    //         employeeId: currentEmployee,
    //         actionId: currentEmployee,
    //         txnPayrollPeriodId: payrollPeriodId,
    //         departmentId: departmentFilter,
    //         employmentTypeId: employmentTypeFilter,
    //         roleId: roleFilter,
    //         workInLocationId: workInFilter,
    //         paymentMethod: paymentTypeMethod,
    //         // searchTxt: searchTxt,
    //         status: status,
    //         type: "count",
    //         ...params,
    //     })
    //     // dispatch(setEmployeeListCount(response?.data?.content))
    // }
    const callByGroup = useCallback(
        async (params) => {
            dispatch(setIsLoadingFile(true));
            try {
                let status = pageStatus;
                console.log("params?.branch", params?.branch, params?.department);

                let response = await service.getEmployeeGroupCalculationInfo({
                    txnPayrollPeriodId: payrollPeriodId,
                    branch: params?.branch?.join?.(","),
                    department: params?.department?.join?.(",")
                })
                console.log("response", response?.data?.content);

                const {
                    department,
                    branch,
                    total
                } = response?.data?.content;

                setDepartmentList(department);
                setBranchList(branch);
                setOpenCalGroup({
                    open: true,
                    total: total
                })
                formCalGroup.setFieldValue('total', total ?? 0)
            } catch (err) {
                message.error(
                    err?.response?.data?.message || 'กรุณาลองใหม่อีกครั้ง'
                );
            } finally {
                dispatch(setIsLoadingFile(false));
            }
        },
        [dispatch, formCalGroup, pageStatus, payrollPeriodId],
    )


    const onGroupCalculate = useCallback(() => {
        callByGroup()
        // navigate(`/payroll/payment/group_calculation/${payrollPeriodId}`)
    }, [callByGroup])

    const getTxnPaymentListByPaginationSize = useCallback(async (params) => {
        // console.log("selectedPaginationSize", selectedPaginationSize);
        console.log("param", params);
        dispatch(setIsLoadingFile(true))
        await service.getEmployeeGroupCalculationPaging({
            branch: params?.branchId?.join?.(","),
            department: params?.departmentId?.join?.(","),
            companyId: currentCompany,
            employeeId: currentEmployee,
            actionId: currentEmployee,
            txnPayrollPeriodId: id,
            page: 0,
            size: 100
        }).then((res) => {
            console.log("res?.data?.content", res?.data?.content);
            let ids = []
            res?.data?.content.forEach(o => {
                const { income, deduction } = o
                // console.log("income, deduction", income, deduction);
                // setCalSuccess();
                ids.push(o.id)
                income.forEach(inc => {
                    if (inc?.income?.code == 'I01') {
                        form.setFieldValue(`I01amount_${o.id}`, inc.amount)
                        form.setFieldValue(`I01unit_${o.id}`, inc.unit)
                    } else {

                        console.log("income, deduction", `${inc.id}_amount_${o.id}`, inc.unit);
                        form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                        form.setFieldValue(`${inc.id}_unit_${o.id}`, inc.unit)
                    }
                })
                deduction.forEach(inc => {
                    form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                })
            })
            // setCalSuccess(ids);
            dispatch(setEmployeeGroupCalculation(res?.data?.content))
        })
        dispatch(setIsLoadingFile(false))
        navigate(`/payroll/payment/group_calculation/${payrollPeriodId}`)
    }, [dispatch, currentCompany, currentEmployee, id, navigate, payrollPeriodId, form])

    const ItemLabel = ({ icon, title, desc }) => (
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
                style={{
                    width: 56,
                    height: 56,
                    borderRadius: 16,
                    background: "#EEF4FF",
                    display: "flex",
                    fontFamily: 'NotoSansThai',
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#1677ff",
                    fontSize: 20,
                }}
            >
                {icon}
            </div>

            <div>
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                    {title}
                </div>
                <div style={{ color: "#8c8c8c", fontSize: 10 }}>
                    {desc}
                </div>
            </div>
        </div>
    );

    const modelCalGroup = useCallback(
        () => {
            return <Modal
                open={openCalGroup.open}
                width={"45%"}
                footer={null}
                closable
                destroyOnClose
                onCancel={closeCalGroupModal}
            >
                <Spin spinning={isLoadingFile} fullscreen />
                <FormAntd form={formCalGroup}>
                    {/* ============================= STEP 1 ============================= */}
                    {calGroupStep === 1 && (
                        <>
                            <Space align="start" size={10} style={{ marginBottom: 0 }}>
                                <span style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    background: '#2563EB',
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: 14,
                                    flexShrink: 0,
                                }}>
                                    1
                                </span>
                                <Typography.Title level={2} style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                    margin: 0,
                                    fontFamily: 'NotoSansThai',
                                }}>
                                    ดาวน์โหลดข้อมูลเงินเดือน
                                </Typography.Title>
                            </Space>

                            <Typography.Text style={{
                                display: 'block',
                                fontSize: 12,
                                color: "#6B7280",
                                fontFamily: 'NotoSansThai',
                                marginLeft: 40,
                                marginBottom: 10,
                            }} type="secondary">
                                เลือกกลุ่มพนักงานที่ต้องการจัดทำเงินเดือน จากนั้นดาวน์โหลดไฟล์ Excel
                                เพื่อนำไปกรอกหรือแก้ไขข้อมูล
                            </Typography.Text>

                            <FormItem
                                style={{ marginTop: 32, fontSize: 12 }}
                                shouldUpdate={(prev, curv) => {
                                    if (
                                        prev.branchId !== curv.branchId ||
                                        prev.departmentId !== curv.departmentId
                                    ) {
                                        callByGroup({
                                            branch: curv.branchId,
                                            department: curv.departmentId,
                                        });
                                    }

                                    return (
                                        prev.branchId !== curv.branchId ||
                                        prev.departmentId !== curv.departmentId
                                    );
                                }}
                            >
                                {() => (
                                    <Row gutter={[0, 24]}>
                                        <Col span={6}>
                                            <ItemLabel
                                                icon={<BankOutlined />}
                                                title="แผนก"
                                                desc="เลือกแผนกที่ต้องการ"
                                            />
                                        </Col>

                                        <Col span={18}>
                                            <FormSelect
                                                name="departmentId"
                                                vertical={false}
                                                mode="multiple"
                                                placeholder="ทั้งหมด"
                                                size="large"
                                                allowClear
                                                options={modifiedDepartmentList}
                                            />
                                        </Col>

                                        <Col span={6}>
                                            <ItemLabel
                                                icon={<EnvironmentOutlined />}
                                                title="สาขา"
                                                desc="เลือกสาขาที่ต้องการ"
                                            />
                                        </Col>

                                        <Col span={18}>
                                            <FormSelect
                                                name="branchId"
                                                vertical={false}
                                                mode="multiple"
                                                placeholder="ทั้งหมด"
                                                size="large"
                                                allowClear
                                                options={modifiedBranchList}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <ItemLabel
                                                icon={<TeamOutlined />}
                                                title="จำนวนพนักงาน"
                                            // desc="ระบุจำนวนพนักงานในกลุ่มนี้"
                                            />
                                        </Col>
                                        <Col span={18}>
                                            <FormInput
                                                name="total"
                                                vertical={false}
                                                disabled
                                                size="large"
                                                placeholder="ระบุจำนวนพนักงาน"
                                                addonAfter="คน"
                                            />
                                        </Col>
                                    </Row>
                                )}
                            </FormItem>

                            {/* กลุ่มพนักงาน card */}
                            {/* <div style={{
                                marginTop: 24,
                                border: '1px solid #E5E7EB',
                                borderRadius: 12,
                                padding: 20,
                            }}>
                                <Typography.Text style={{
                                    display: 'block',
                                    fontWeight: 700,
                                    fontSize: 15,
                                    marginBottom: 16,
                                    fontFamily: 'NotoSansThai',
                                }}>
                                    กลุ่มพนักงาน
                                </Typography.Text>

                                <Radio.Group
                                    value={employeeGroupMode}
                                    onChange={(e) => setEmployeeGroupMode(e.target.value)}
                                    style={{ width: '100%' }}
                                >
                                    <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                        <Radio value="all">
                                            <Typography.Text strong style={{ fontFamily: 'NotoSansThai' }}>
                                                พนักงานทั้งหมดตามเงื่อนไข
                                            </Typography.Text>
                                            <br />
                                            <Typography.Text type="secondary" style={{ fontSize: 13, fontFamily: 'NotoSansThai' }}>
                                                ดาวน์โหลดพนักงานทั้งหมดที่ตรงกับแผนกและสาขาที่เลือก
                                            </Typography.Text>
                                        </Radio>

                                        <Radio value="partial">
                                            <Typography.Text strong style={{ fontFamily: 'NotoSansThai' }}>
                                                เลือกบางส่วน
                                            </Typography.Text>
                                            <br />
                                            <Typography.Text type="secondary" style={{ fontSize: 13, fontFamily: 'NotoSansThai' }}>
                                                เลือกจำนวนพนักงานตามลำดับรหัสพนักงาน (ระบบจะนับต่อจากครั้งล่าสุด)
                                            </Typography.Text>
                                        </Radio>

                                        {employeeGroupMode === 'partial' && (
                                            <div style={{
                                                background: '#F9FAFB',
                                                borderRadius: 8,
                                                padding: 16,
                                                marginLeft: 24,
                                            }}>
                                                <Row align="middle" gutter={12}>
                                                    <Col>
                                                        <Typography.Text style={{ fontFamily: 'NotoSansThai' }}>
                                                            จำนวนพนักงานที่ต้องการ
                                                        </Typography.Text>
                                                    </Col>
                                                    <Col>
                                                        <FormItem name="total" noStyle initialValue={100}>
                                                            <InputNumber min={1} size="large" style={{ width: 140 }} />
                                                        </FormItem>
                                                    </Col>
                                                    <Col>
                                                        <Typography.Text style={{ fontFamily: 'NotoSansThai' }}>
                                                            คน
                                                        </Typography.Text>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )}
                                    </Space>
                                </Radio.Group>
                            </div> */}
                            <Divider />

                            <Row justify="end">
                                <Space>
                                    <Button size="large" onClick={closeCalGroupModal}>
                                        ยกเลิก
                                    </Button>

                                    <Button
                                        icon={xlsxIcon()}
                                        size="large"
                                        disabled={isLoadingFile}
                                        style={{ borderColor: "#22c55e", color: "#22c55e" }}
                                        onClick={() => {
                                            // move to step 2 after triggering the download
                                            setCalGroupStep(2);
                                        }}
                                    >
                                        ดาวน์โหลดเอกสารทำเงินเดือน
                                    </Button>

                                    <Button
                                        type="primary"
                                        size="large"
                                        disabled={isLoadingFile}
                                        onClick={() =>
                                            getTxnPaymentListByPaginationSize(
                                                formCalGroup.getFieldsValue(true)
                                            )
                                        }
                                    >
                                        คำนวณในระบบ
                                    </Button>
                                </Space>
                            </Row>

                            <Row justify="start" style={{ marginTop: 12 }}>
                                <Space size={6}>
                                    <BulbFilled style={{ color: '#F59E0B' }} />
                                    <Typography.Text type="secondary" style={{ fontSize: 13, fontFamily: 'NotoSansThai' }}>
                                        หรือสามารถกด "คำนวณในระบบ" เพื่อทำเงินเดือนเฉพาะพนักงานที่เลือก
                                        โดยไม่ต้องดาวน์โหลดไฟล์
                                    </Typography.Text>
                                </Space>
                            </Row>
                        </>
                    )}

                    {/* ============================= STEP 2 ============================= */}
                    {calGroupStep === 2 && (
                        <>
                            <Space align="start" size={12} style={{ marginBottom: 0 }}>
                                <span style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    background: '#2563EB',
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: 14,
                                    flexShrink: 0,
                                }}>
                                    2
                                </span>
                                <Typography.Title level={2} style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                    margin: 0,
                                    fontFamily: 'NotoSansThai',
                                }}>
                                    นำเข้าข้อมูลเงินเดือน
                                </Typography.Title>
                            </Space>

                            <Typography.Text style={{
                                display: 'block',
                                fontSize: 12,
                                color: "#6B7280",
                                fontFamily: 'NotoSansThai',
                                marginLeft: 40,
                            }} type="secondary">
                                อัปโหลดไฟล์ Excel ที่ดาวน์โหลดจากระบบและกรอกข้อมูลเรียบร้อยแล้ว
                                เพื่อนำข้อมูลเงินเดือนเข้าสู่ระบบ
                            </Typography.Text>

                            <Upload.Dragger
                                accept=".xls,.xlsx"
                                multiple
                                fileList={uploadFiles}
                                beforeUpload={(file) => {
                                    const fileWithUid = Object.assign(file, {
                                        uid: file.uid || `${file.name}-${file.size}-${file.lastModified}`,
                                    });
                                    setUploadFiles((prev) => [...prev, fileWithUid]);
                                    return false;
                                }}
                                onRemove={(file) => {
                                    setUploadFiles((prev) => prev.filter((f) => f.uid !== file.uid));
                                }}
                                style={{
                                    marginTop: 10,
                                    borderRadius: 12,
                                    // padding: '40px 0',
                                    background: '#FAFBFF',
                                }}
                            >
                                <p style={{ marginBottom: 16 }}>
                                    <CloudUploadOutlined style={{ fontSize: 40, color: '#2563EB' }} />
                                </p>
                                <p style={{ fontWeight: 700, fontSize: 15, fontFamily: 'NotoSansThai', marginBottom: 4 }}>
                                    วางไฟล์ที่นี่ หรือเลือกไฟล์จากอุปกรณ์
                                </p>
                                <p style={{ color: '#9CA3AF', fontSize: 13, fontFamily: 'NotoSansThai', marginBottom: 20 }}>
                                    รองรับไฟล์ .xls และ .xlsx ที่ดาวน์โหลดจากระบบเท่านั้น
                                </p>
                                <Button
                                    type="primary"
                                    size="large"
                                    icon={<FolderOpenOutlined />}
                                    onClick={(e) => e.preventDefault()}
                                >
                                    เลือกไฟล์
                                </Button>
                            </Upload.Dragger>

                            <div style={{
                                marginTop: 16,
                                background: '#F0FDF4',
                                border: '1px solid #BBF7D0',
                                borderRadius: 12,
                                padding: 16,
                            }}>
                                <Row justify="space-between" align="middle" gutter={16}>
                                    <Col flex="auto">
                                        <Space align="start">
                                            {xlsxIcon()}
                                            <div>
                                                <Typography.Text strong style={{ fontFamily: 'NotoSansThai', display: 'block' }}>
                                                    ยังไม่มีไฟล์สำหรับกรอกข้อมูล?
                                                </Typography.Text>
                                                <Typography.Text type="secondary" style={{ fontSize: 13, fontFamily: 'NotoSansThai' }}>
                                                    กลับไปเลือกกลุ่มพนักงานและดาวน์โหลดไฟล์ Excel ก่อนนำเข้าข้อมูล
                                                </Typography.Text>
                                            </div>
                                        </Space>
                                    </Col>
                                    <Col>
                                        <Button
                                            icon={<DownloadOutlined />}
                                            style={{ borderColor: "#22c55e", color: "#22c55e" }}
                                            disabled={isLoadingFile}
                                            onClick={() => {
                                                let params = formCalGroup.getFieldsValue(true);
                                                modalDownload({
                                                    companyId: currentCompany,
                                                    employeeId: currentEmployee,
                                                    actionId: currentEmployee,
                                                    txnPayrollPeriodId: id,
                                                    branch: params?.branchId?.join?.(","),
                                                    department: params?.departmentId?.join?.(","),
                                                    groupMode: employeeGroupMode,
                                                    total: employeeGroupMode === 'partial' ? params?.total : undefined,
                                                });
                                            }}
                                        >
                                            {`ดาวน์โหลดไฟล์ใหม่ (${formCalGroup.getFieldValue("total")})`}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            <div style={{
                                marginTop: 16,
                                background: '#EFF6FF',
                                borderRadius: 12,
                                padding: 16,
                            }}>
                                <Space align="start">
                                    <InfoCircleFilled style={{ color: '#2563EB' }} />
                                    <Typography.Text style={{ fontSize: 13, fontFamily: 'NotoSansThai' }}>
                                        กรุณาใช้ไฟล์ล่าสุดที่ดาวน์โหลดจากระบบ
                                        และไม่แก้ไขชื่อคอลัมน์หรือโครงสร้างของไฟล์
                                    </Typography.Text>
                                </Space>
                            </div>

                            <Divider />

                            <Row justify="end">
                                <Space>
                                    {/* Cancel on step 2 goes back to step 1, it does NOT close the modal */}
                                    <Button size="large" onClick={() => setCalGroupStep(1)}>
                                        ยกเลิก
                                    </Button>

                                    <Button
                                        type="primary"
                                        size="large"
                                        disabled={uploadFiles?.length === 0}
                                        loading={isLoadingFile}
                                        onClick={handleImportEmployeeGroupCalculation}
                                    >
                                        นำเข้าข้อมูล
                                    </Button>
                                </Space>
                            </Row>
                        </>
                    )}
                </FormAntd>
            </Modal>
        },
        [openCalGroup.open, closeCalGroupModal, formCalGroup, calGroupStep, uploadFiles, isLoadingFile, handleImportEmployeeGroupCalculation, callByGroup, modifiedDepartmentList, modifiedBranchList, getTxnPaymentListByPaginationSize, modalDownload, currentCompany, currentEmployee, id, employeeGroupMode],
    )



    const getPageByGroup = useCallback(() => {

        switch (pageByStep) {
            case "1":
                return <CalculationPage
                    exportTxnPayment={exportTxnPayment}
                    PAYMENT_TAB={PAYMENT_TAB}
                    STATUS_TYPE={STATUS_TYPE}
                    getTable={getCalculateTable}
                    getVisibleIcon={getVisibleIcon}
                    searchTxt={searchTxt}
                    onChange={onChange}
                    onSearch={onSearch}
                    onClearSearchTxt={onClearSearchTxt}
                    payrollPeriod={payrollPeriod}
                    isLoading={isLoading}
                    isLoadingFile={isLoadingFile}
                    onEditPayroll={onEditPayroll}
                    onPageStatusChange={onPageStatusChange}
                    updateHeaderStatusToVerification={updateHeaderStatusToVerification}
                    updateStatusToPending={updateTxnPaymentStatusToPending}
                    totalEmployeeTab={totalEmployeeTab}
                    pageStatus={pageStatus}
                    rowSelected={rowSelected}
                    onGroupCalculate={onGroupCalculate}
                    modelCalGroup={modelCalGroup}
                />;
            case "2":
                return <VerificationPage
                    confirmModalFn={confirmModalFn}
                    getTable={getVerificationTable}
                    getVisibleIcon={getVisibleIcon}
                    VERIFICATION_TYPE={VERIFICATION_TYPE}
                    countTxnPaymentByStatus={countTxnPaymentByStatus}
                    sendSalaryCertificateFn={sendSalaryCertificateFn}
                    searchTxt={searchTxt}
                    onChange={onChange}
                    onSearch={onSearch}
                    exportStatus={exportStatus}
                    onClearSearchTxt={onClearSearchTxt}
                    payrollPeriod={payrollPeriod}
                    isLoading={isLoading}
                    onEditPayroll={onEditPayroll}
                    onPageTypeChange={onPageStatusChange}
                    updateTxnPaymentStatusToPending={updateTxnPaymentStatusToPending}
                    updateHeaderStatusToApproval={updateHeaderStatusToApproval}
                    updateHeaderStatusToCal={updateHeaderStatusToCal}
                    totalEmployeeTab={totalEmployeeTab}
                    updateTxnPaymentStatusToCalculate={updateTxnPaymentStatusToCalculate}
                    updateTxnPaymentStatusToReject={updateTxnPaymentStatusToReject}
                    rowSelected={rowSelected}
                    pageStatus={pageStatus}
                    onRejectModalOpen={onRejectModalOpen}
                    getModal={getRejectReasonModal}
                    exportTxnPayment={exportTxnPayment}
                    modifiedExportStatusDropdown={modifiedExportStatusDropdown}
                    onExportStatusChange={onExportStatusChange}
                    isModalSalaryOpen={isModalSalaryOpen}
                    setIsModalSalaryOpen={setIsModalSalaryOpen}
                    isDownload={isDownload}
                    isSlipDownload={isSlipDownload}
                    exportPaymentSlip={exportPaymentSlip}
                />;
            case "3":
                return <ApprovalPage
                    confirmModalFn={confirmModalFn}
                    getTable={getApprovalTable}
                    getVisibleIcon={getVisibleIcon}
                    searchTxt={searchTxt}
                    onChange={onChange}
                    onSearch={onSearch}
                    onClearSearchTxt={onClearSearchTxt}
                    payrollPeriod={payrollPeriod}
                    isLoading={isLoading}
                    onEditPayroll={onEditPayroll}
                    onPageTypeChange={onPageStatusChange}
                    totalEmployeeTab={totalEmployeeTab}
                    updateHeaderStatusToClose={updateHeaderStatusToClose}
                    updateTxnPaymentStatusToReject={updateTxnPaymentStatusToReject}
                    onRejectModalOpen={onRejectModalOpen}
                    getModal={getRejectReasonModal}
                />;
            case "4":
                return <ClosePage
                    confirmModalFn={confirmModalFn}
                    getTable={getCloseTable}
                    getVisibleIcon={getVisibleIcon}
                    searchTxt={searchTxt}
                    onChange={onChange}
                    onSearch={onSearch}
                    onClearSearchTxt={onClearSearchTxt}
                    payrollPeriod={payrollPeriod}
                    isLoading={isLoading}
                    isTextFileLoading={isTextFileLoading}
                    onEditPayroll={onEditPayroll}
                    onPageTypeChange={onPageStatusChange}
                    totalEmployeeTab={totalEmployeeTab}
                    updateHeaderStatusToApproval={updateHeaderStatusToApproval}
                    updateHeaderStatusToPayment={updateHeaderStatusToPayment}
                    getReport={getReport}
                    getReportBBL={getReportBBL}
                    company={company}
                    exportTextFileBank={exportTextFileBank}
                    isModalDocumentOpen={isModalDocumentOpen}
                    onDocumentModalOpen={onDocumentModalOpen}
                    onDocumentModalClose={onDocumentModalClose}
                />;
            case "5":
                return <PaymentPage
                    getTable={getPaymentTable}
                    getVisibleIcon={getVisibleIcon}
                    searchTxt={searchTxt}
                    onChange={onChange}
                    onSearch={onSearch}
                    onClearSearchTxt={onClearSearchTxt}
                    payrollPeriod={payrollPeriod}
                    isLoading={isLoading}
                    onEditPayroll={onEditPayroll}
                    onPageTypeChange={onPageStatusChange}
                    totalEmployeeTab={totalEmployeeTab}
                    updateHeaderStatusToPayment={updateTxnPayrollPeriodHeaderStatusToPaid}
                />;
            default:
                return null
        }
    }, [
        totalEmployeeTab,
        pageByStep,
        PAYMENT_TAB,
        pageStatus,
        searchTxt,
        payrollPeriod,
        isLoading,
        rowSelected,
        exportStatus,
        countTxnPaymentByStatus,
        getReport,
        getReportBBL,
        sendSalaryCertificateFn,
        sendingSalaryCertificateByIdFn,
        getCalculateTable,
        getVerificationTable,
        getApprovalTable,
        getCloseTable,
        getPaymentTable,
        getVisibleIcon,
        onChange,
        onSearch,
        onRejectModalClose,
        onRejectModalOpen,
        getRejectReasonModal,
        onClearSearchTxt,
        onEditPayroll,
        onPageStatusChange,
        updateTxnPaymentStatusToPending,
        updateHeaderStatusToVerification,
        updateHeaderStatusToApproval,
        updateHeaderStatusToClose,
        updateHeaderStatusToPayment,
        updateTxnPaymentStatusToReject,
        updateTxnPaymentStatusToCalculate,
        updateTxnPayrollPeriodHeaderStatusToPaid,
        confirmModalFn,
        onExportStatusChange,
        onGroupCalculate
    ]);


    useMemo(() => {
        getPageByGroup()
    }, [getPageByGroup])

    useEffect(() => {
        let modifiedIncome = employmentIncome?.map(obj => {
            let exists = employeeIncome?.some((o) => o?.id === obj?.id);
            return {
                ...obj,
                status: exists ? "Y" : "N"
            }
        }) || [];
        let modifiedDeduct = employmentDeduct?.map(obj => {

            let exists = employeeDeduct?.some((o) => o?.id === obj?.id);
            return {
                ...obj,
                status: exists ? "Y" : "N"
            }
        }) || [];
        setIncomeSetup(modifiedIncome)
        setDeductSetup(modifiedDeduct)

    }, [employeeIncome, employeeDeduct, employmentIncome, employmentDeduct])


    useEffect(() => {

        if (employeeIncomeDeduction?.incomes) {
            let income = employeeIncomeDeduction?.incomes?.map((o) => {
                return {
                    ...o,
                    amount: o?.amount ? get2DecimalPointsWithCommas(o?.amount) : 0.00,
                    unit: o?.unit ? get2DecimalPointsWithCommas(o?.unit) : 0.00,
                    type: "income"
                }
            })

            setEmployeeIncome(income)
        }

        if (employeeIncomeDeduction?.deductions) {
            let deduction = employeeIncomeDeduction?.deductions?.map((o) => {
                return {
                    ...o,
                    amount: o?.amount ? get2DecimalPointsWithCommas(o?.amount) : 0,
                    type: "deduction"
                }
            })
            setEmployeeDeduct(deduction)
        }
    }, [employeeIncomeDeduction])


    // useEffect(() => {
    //     getRole()
    //     getDepartment()
    //     getWorkInLocation()
    //     getEmploymentType()
    // }, [currentCompany])

    useEffect(() => {
        if (currentCompany) {
            getCompany();
        }
    }, [currentCompany, getCompany]);


    useEffect(() => {
        if (payrollPeriodId) {
            getPayrollPeriod(payrollPeriodId)
        }
    }, [pageByStep, pageStatus, tab])

    useEffect(() => {
        if (tab) {
            setPagination({
                page: 0, size: 10
            })
        }
    }, [tab])

    useEffect(() => {
        console.log("sssssss", pageStatus,
            pageByStep,
            tab);

        if (payrollPeriodId && pageStatus && pageByStep && tab) {
            if (exportStatus != null) {
                setExportStatus(null)
            } else {
                getEmployeeList({ page: 0, size: 10 })
            }
        }
    }, [pageStatus, pageByStep, tab])

    useEffect(() => {
        console.log("exportStatus ", exportStatus, searchTxt);
        const modifiedRevalues = {
            ...searchTxt,
            exportStatus: exportStatus,
            page: 0,
            size: 10
        }
        getEmployeeList(modifiedRevalues)
    }, [exportStatus, searchTxt])

    // * call when first render
    useEffect(() => {
        if (payrollPeriodId) {
            getTotalEmployeeTab()
            getEmploymentIncomeDeductionByTxnPayrollPeriodIdFn()
        }
    }, [])




    useEffect(() => {
        if (payrollPeriod && pageByStep) {
            getCountTxnPaymentByStatus()
        }
    }, [pageByStep])

    useEffect(() => {
        if (currentTxnPayment) {
            getEmploymentTypeIncomeDeductForSetup();
        }
    }, [currentTxnPayment])


    return {
        getCalculateTable,
        onChange,
        onPageStatusChange,
        onCancel,
        getModal,
        updateStatus,
        onPageChange,
        setDepartmentFilter,
        setEmploymentTypeFilter,
        setRoleFilter,
        setWorkInFilter,
        returnPayment,
        payrollPeriod,
        departmentList: modifiedDepartmentList,
        roleList: modifiedRoleList,
        workInLocationList: modifiedWorkInLocationList,
        employmentTypeList: modifiedEmploymentTypeList,
        paymentMethodList: modifiedPaymentMethod,
        isLoading,
        isTextFileLoading,
        onEditPayroll,
        onSubmitEditPayroll,
        onSearch,
        setPaymentTypeMethod,
        modifiedPaymentStep: modifiedStep,
        visible,
        setVisible,
        PAYMENT_TAB,
        getOvertimeInPeriod,
        createPaymentByEmployeeIds,
        onClearSearchTxt,
        searchTxt,
        onRejected,
        getEmploymentIncomeDeductionTypeModal,
        // onSearch
        onResetList,
        onPageByStepChange,
        getPageByGroup,
        onConfirmReset,
        modifiedExportStatusDropdown,
        isModalSalaryOpen,
        setIsModalSalaryOpen,
        getEmploymentTypeIncomeDeductForSetup,
        employmentIncome,
        employmentDeduct
    }
}
export default usePayment